import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  ViewChild,
  ElementRef,
  OnDestroy,
  AfterViewInit,
  ChangeDetectorRef,
} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { saveAs } from 'file-saver';
import { UtilsService } from 'app/shared/utils.service';
import JSZip from 'jszip';
import {
  RoleEnum,
  S3FileInput,
  FileTypeEnum,
  GetAnswerQuery,
  GetAssignmentQuery,
  RiskAction,
  CreateCommentInput,
  UpdateCommentInput,
  ExportSourceEnum,
  GetCommentQuery,
  GetRoleQuery,
  APIService,
  TaskStatusEnum,
  PartialRepresentationEnum,
  CreateArtifactsRegistryInput,
  DeleteArtifactsRegistryInput,
  ModelArtifactsRegistryFilterInput,
  ArtifactStatus,
} from 'app/API.service';
import { FileService } from '../../file.service';
import { NGXLogger } from 'ngx-logger';
import { Question } from 'models/questionnaire.model';
import { QuestionnaireService } from 'app/collection/questionnaire.service';
import { RiskRegisteryEnum } from '../../enums/risk-registery.enum';
import { CommentActionEnum } from '../../enums/question-card.enum';
import { AnswerEnum, BnbAnswerEnum } from '../../enums/answer.enum';
import { v4 as uuid } from 'uuid';
import { CapitalizationRulePipe } from 'app/shared/pipes/capitalization-rule.pipe';
import { SunburstService } from 'app/break-down/sunburst.service';
import { SecurityControlDetailsService } from 'app/shared/security-control-details/security-control-details.service';
import { Subscription } from 'rxjs';
import { RemediationService } from 'app/remediation/remediation.service';
import { SortDirectionEnum } from 'app/shared/enums/sort-direction.enum';
import { UserService } from 'app/shared/user.service';
import { AppLevelRoleEnum } from 'app/shared/enums/appLevelRoles.enum';
import { CollectionService } from 'app/collection/collection.service';
import { LogsKeyEnum, LogsTypeEnum } from 'app/shared/enums/logsKey.enum';
import { FrameworkEnumTypes } from 'app/shared/enums/framework-enum-types.enum';
import { DomainFrameworkService } from 'app/shared/domain-framework.service';
import { ManagerActionEnum } from 'app/shared/enums/manager-action.enum';
import { trigger } from '@angular/animations';
import { ArrowsEnum } from 'app/shared/enums/shared.enum';
import { getLogMessage } from 'app/shared/helpers/logs.helper';
import { EntityService } from 'app/shared/entity.service';
import { CUSTOMAPIService } from 'app/custom-api.service';
import { NgbActiveModal, NgbModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { SVG } from 'app/shared/enums/integration.enum';
import { TASK_OWNER_ENABLED_ANSWERS } from 'app/remediation/remediation.constant';
import { SMART_USER, Defaults } from 'app/constants';
import { RTL_FRAMEWORKS } from 'app/collection/collection.constant';
// eslint-disable-next-line max-len
import { CollectionQuestionLinkUploadComponent } from 'app/collection/collection-question-tab/collection-question-link-upload/collection-question-link-upload.component';
// eslint-disable-next-line max-len
import { CollectionExistingFilesFirstPartyComponent } from 'app/collection/collection-existing-files/collection-existing-files-first-party/collection-existing-files.component';
import { FrameworkTreeService } from 'app/shared/framework-tree.service';
@Component({
  selector: 'cygov-question-card-ui',
  templateUrl: './question-card-ui.component.html',
  styleUrls: ['./question-card-ui.component.scss'],
  providers: [CapitalizationRulePipe],
  animations: [trigger('openingAnimation', [])],
  standalone: false,
})
export class QuestionCardUiComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() practices: any;
  @Input() questionsInfo: any;
  @Input() riskRegistery: RiskRegisteryEnum = RiskRegisteryEnum.Normal;
  @Input() showQuestionWithoutUser: boolean;
  @Input() closeRemediateModal: boolean = false;
  @Input() userId: string;
  @Input() comment = '';
  @Input() answersFilter: string[] = [];
  @Input() assignments: GetAssignmentQuery[] = [];
  @Output() save = new EventEmitter<Question[]>();
  @ViewChild('uploadArtifact') uploadInput: ElementRef;

  //* Partial representation enum reference */
  readonly PARTIAL_REPRESENTATION_ENUM = PartialRepresentationEnum;
  currentPartialRepresentation: PartialRepresentationEnum[] = [];

  ENABLED_ANSWERS = TASK_OWNER_ENABLED_ANSWERS;
  questions: any = [];
  prevQid: any;
  preI: any;
  answerEnum = AnswerEnum;
  bnbAnswerEnum = BnbAnswerEnum;
  hasPermission = false;
  hasApprovalPermission = false;
  hasInfoSecPermission: boolean = UtilsService.isBnB;
  isBnbRisk: boolean = false;
  isRemediate: boolean = false;
  isDataFetched: boolean = true;
  confirmationMessage = 'Do you really want to delete the selected artifact?';
  selectedUserAnswer: GetAnswerQuery;
  possibleAnswers: string[];
  bnbPossibleAnswer: string[];
  answers = [];
  saving = false;
  changedAnswers: Map<number, GetAnswerQuery> = new Map();
  entityId: string;
  showError: boolean;
  collapsedQuestion: boolean[] = [];
  questionsNewComment: Map<string, string> = new Map<string, string>();
  questionsAuditComment: Map<string, string> = new Map<string, string>();
  currentUser: any;
  newLineCapital = false;
  commentLength = 0;
  isThirdPartyView = false;
  isVendorView: boolean = false;
  langDirectionClass: string;
  isPartialSelected: boolean[] = [];
  sliderScore: number[] = [-1];
  sliderValues: number[] = [0, 2.5, 5, 7.5];
  riskFrameworks: string[] = [];
  isFromVendorOrThirdParty: boolean = false;
  subscription: Subscription[] = [];
  assignedUsers = [];
  currentUserRole: GetRoleQuery; //  Adding currentUserRole which will be removed and replaced with user.role after making connection.
  isHigherRole: boolean = false;
  isCRB: boolean = false;
  auditComments: any[] = [];
  userComments: any[] = [];
  prevAns: any = null; // saving the previous answer so that when file is not uploaded it should be used.
  VendorRiskFrameworkEnum: any;
  remediatedItemsList = [];
  showActivity: boolean = false;
  isBeecher: boolean = UtilsService.isBnBCyberSite;
  isBnb: boolean = UtilsService.isBnB;
  currentSelectedAnswer: string = '';
  currentPossibleAnswer: string = '';
  mandatoryText: string = '';
  commentAnswerMapper: any = {};
  maxCharsInLine: number = 100;
  arrowsEnum = ArrowsEnum;
  currentSelectedUserId;
  tempQuestionsAnswers: any = [];
  updatedAnswers: any[] = [];
  isUserItSelf: boolean = false;
  isCommentInProgress: boolean = false;
  cachedAnswers: any[] = [];
  INTEGRATION_SVG = SVG.INTEGRATION;
  smartUser: boolean;
  SMART_MAPPING_SVG = SVG.SMART_MAPPING;
  artifactsLogsToCreate: any[] = []; //* To store logs related to artifact uploads for Control Navigator
  //* Pending artifacts that will be saved when user clicks save button
  pendingLinkedArtifacts: Map<number, { artifactIds: string[]; artifacts: any[] }> = new Map();
  // Files to delete from registry on save (keyed by question index)
  pendingDeletedFiles: Map<number, Array<{ fileId: string; questionId: string; answerId: string }>> = new Map();
  pendingUploadedFiles: Map<
    number,
    {
      files: any[];
      uploadedFiles: any[];
      fileArtifactMap: Map<string, { fileId: string; topLevelArtifactId: string; fileName: string }>;
      uploadedCount: number;
    }
  > = new Map();
  processingPendingArtifacts: Set<number> = new Set(); // Track which questions are currently processing pending artifacts
  // Cache flattened framework trees: assessmentId -> questionId -> questionNode
  frameworkTreeCache: Map<string, Map<string, any>> = new Map();
  // Artifact data cache for download (1st party only): questionId -> Map<fileId, { fileId, parentID, entityId }>
  artifactDataCacheByQuestion = new Map<string, Map<string, { fileId: string; parentID: string; entityId: string }>>();
  // Artifact name cache: questionId -> Map<artifactId, artifactName>
  artifactNameCacheByQuestion = new Map<string, Map<string, string>>();
  unZippedFiles: any = [];

  //* Global Control related Variables
  globalControlUser: boolean = false;
  readonly GLOBAL_CONTROL_SVG = SVG.GLOBAL_CONTROL;
  readonly GLOBAL_CONTROL_EMAIL = Defaults.GlobalControlEmail;
  selectedQuestion: any = null;
  modalReference: NgbModalRef;
  modalOptionsUploadScreen: NgbModalOptions = {
    windowClass: 'upload-content-modal question-card-upload-modal',
    backdropClass: 'upload-content-modal-backdrop question-card-upload-backdrop',
    centered: true,
  };
  modalOptionsExistingFiles: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    windowClass: 'existing-file-modal',
    backdropClass: 'existing-file-modal-backdrop',
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private remediationService: RemediationService,
    private questionnaireService: QuestionnaireService,
    private fileService: FileService,
    private toastrService: ToastrService,
    private logger: NGXLogger,
    private securityService: SecurityControlDetailsService,
    public capitalization: CapitalizationRulePipe,
    private sunburstService: SunburstService,
    private userService: UserService,
    private api: APIService,
    private customApi: CUSTOMAPIService,
    private collectionService: CollectionService,
    private domainFrameworkService: DomainFrameworkService,
    private entityService: EntityService,
    private cdr: ChangeDetectorRef,
    public activeModal: NgbActiveModal,
    private controlDetailsService: SecurityControlDetailsService,
    private modalService: NgbModal,
    private frameworkTreeService: FrameworkTreeService
  ) {
    this.VendorRiskFrameworkEnum = this.fileService.importFrameworkEnumsFromS3(
      FrameworkEnumTypes.VENDOR_RISK_FRAMEWORK_ENUM
    );
  }

  ngOnChanges(): void {
    if (this.closeRemediateModal) {
      this.currentSelectedAnswer = '';
      this.collectionService.commentAnswerMapper = {};
    }
    if (this.questions && this.questions.length) {
      // Remove Duplicate Assignments
      this.questions.forEach(question => {
        if (question.assignments?.length > 1) {
          question.assignments = this.getUniqueAssignments(question.assignments, true);
        }
      });
      this.buildAnswerList();
      this.questions.map(
        question => (
          (this.questionsNewComment[this.isRemediate ? question.questionIds[0] : question.id] = ''),
          (this.questionsAuditComment[this.isRemediate ? question.questionIds[0] : question.id] = '')
        )
      );
    }
  }

  ngOnInit(): void {
    void this.initializeComponent();
  }

  private async initializeComponent(): Promise<void> {
    this.hasPermission = this.collectionService.hasPermission();
    this.isRemediate = !this.router.url.includes('break-down');
    this.isHigherRole = this.ifHigherRoles();
    this.isCRB = UtilsService.isCRB;
    // in case of breakdown screen there is a bit different data flow
    // isDataFetched will help to maintain loader on modal.
    this.isDataFetched = this.isRemediate;
    this.questions = this.isRemediate
      ? await this.remediationService.filteredTasks(this.questionsInfo)
      : await this.remediationService.questionSettingsForBreakDown(this.questionsInfo);

    if (!this.isRemediate) {
      this.questions[0].assignments = this.assignments.filter(assignment => {
        return this.questions[0].left >= assignment.left && this.questions[0].right <= assignment.right;
      });
    }

    this.questions.forEach(question => {
      if (question.assignments && question.assignments.length > 0) {
        const smartUserAssignment = question.assignments.find(
          assignment => (assignment.user && assignment.user.role === 'SMART_USER') || assignment.userId === SMART_USER
        );
        this.smartUser = !!smartUserAssignment;

        const globalControlUserAssignment = question.assignments.find(
          assignment =>
            assignment.userId === this.GLOBAL_CONTROL_EMAIL ||
            (assignment.user && assignment.user.email === this.GLOBAL_CONTROL_EMAIL)
        );
        this.globalControlUser = !!globalControlUserAssignment;
      }
    });

    if (!this.isRemediate) {
      // in case of breakdown screen
      const answers = await this.remediationService.setAnswers(this.questions, !this.isRemediate);
      const comments = await this.remediationService.fetchComments(this.questions[0]);
      const commentsOnSelectedQuestion = comments.length && comments.filter(c => c.questionId === this.questions[0].id);
      this.questions[0].answers = answers && answers?.length ? answers[0] : [];
      this.questions[0].comments =
        commentsOnSelectedQuestion && commentsOnSelectedQuestion?.length ? commentsOnSelectedQuestion : [];
    }

    this.questions.forEach((ques, idx) => {
      this.commentAnswerMapper[ques.id] = {};
      if (this.isRemediate) {
        if (ques.title.length > 100) {
          this.questionSplitter(idx);
        }
      } else {
        if (ques.name.length > 100) {
          this.questionSplitter(idx);
        }
      }
      const frameworkAnswersWithSettings = this.fileService.getFrameworkAnswersOptions(ques.frameworkName);
      ques.frameworkAnswersWithSettings = frameworkAnswersWithSettings;
      ques.possibleAnswers = Object.values(frameworkAnswersWithSettings).map((e: any) => e.name);

      //* Set Partial Representation for each question
      const settingPartialRep = ques?.settings?.[0]?.partialRepresentation || PartialRepresentationEnum.LEVEL;
      this.currentPartialRepresentation[idx] = settingPartialRep;
    });
    this.buildQuestionsComments();
    this.ngOnChanges();
    this.subscription.push(
      this.securityService.getAssignedUsers().subscribe(users => {
        if (users) {
          // Remove Duplicate Assignments
          users.forEach(user => {
            const tId = user[0]?.taskId;
            if (tId) {
              this.assignedUsers[tId] = user?.length ? this.getUniqueAssignments(user, false) : user;
            }
          });
        }
      })
    );
    this.riskFrameworks = Object.keys(this.VendorRiskFrameworkEnum);
    this.langDirectionClass = Object.keys(RTL_FRAMEWORKS).includes(this.questions[0].frameworkName) ? 'rtl' : 'ltr';
    // this.possibleAnswers =
    //   this.isBeecher || UtilsService.isHowden
    //     ? Object.values(AnswerEnum).filter(val => val !== AnswerEnum.PARTIAL)
    //     : Object.values(AnswerEnum);
    // this.bnbPossibleAnswer = Object.values(BnbAnswerEnum);
    const totalQuestions = this.questions.length;
    this.collapsedQuestion = Array.from(Array<boolean>(totalQuestions).fill(false));
    this.collapsedQuestion[0] = true;
    this.buildAnswerList();
    this.cachedAnswers = JSON.parse(JSON.stringify(this.answers));

    if (UtilsService.isCRB && this.userService.hasPermissionHierarchy(AppLevelRoleEnum.MSSP)) {
      this.hasApprovalPermission = true;
    }

    this.isThirdPartyView = this.router.url.includes('third-party');
    this.isVendorView = this.router.url.includes('vendor');

    this.entityId = UtilsService.getRouteParam(this.route.root.snapshot, 'entityId');
    this.currentUser = await this.userService.getCurrentUser();
    this.currentUserRole = this.userService.getCurrentRole();
    this.isFromVendorOrThirdParty =
      this.currentUserRole.name.toLowerCase() === RoleEnum.VENDOR.toLowerCase() ||
      this.isThirdPartyView ||
      this.isVendorView;
    this.sortCommentsAscending();

    this.questions.forEach((question, index) => {
      question.isCustomScore = question.settings[0]?.isCustomScore || false;
      question.customScoreArray = question.settings[0]?.customScores || null;
      question.isAverageSelected = !question.settings[0]?.isCollaborative;
      question.isVersionClicked = false;
      question.isSeeAllActivity = false;
      question.showFullComment = false;
      question.isEditComments = false;
      question.isCommentDeleted = false;
      question.logsStartIndex = 0;
      question.logsLastIndex = 2;
      question.questionLogs = question?.logs?.slice(question.logsStartIndex, question.logsLastIndex);
      question.disableUpArrow = true;
      question.disableDownArrow = question?.logs?.length < 3;
      question.commentsToUpdate = [];
      question.commentsToDelete = [];
      question.selectedUserAssignment = null;
      const currentUserRole = this.userService.getCurrentRole();
      question.showAverageAvatar =
        this.isHigherRole ||
        currentUserRole.name.toLowerCase() === AppLevelRoleEnum.ENTITY_LEADER.toLowerCase() ||
        currentUserRole.name.toLowerCase() === AppLevelRoleEnum.SUBENTITY_LEADER.toLowerCase();
      //* Handle Single Mode
      if (!question.settings[0]?.isCollaborative) {
        question.showAverageAvatar = true;
        question.isTaskOwner = this.isCurrentUserTaskOwner(question.usersAssignments);
        //* Only show average answer if the avatar is visible
        if (question.showAverageAvatar) {
          this.showAverageAnswer(question, index);
        }
      }
    });
    this.tempQuestionsAnswers = JSON.parse(JSON.stringify(this.questions));
    this.currentSelectedUserId = this.userId;

    if (this.isRemediate) {
      this.remediationService.fetchLogsAndVersionsForRemediation();
    } else {
      this.remediationService.fetchLogsAndVersionsForBreakdown(this.questions);
    }
  }

  getUniqueAssignments(assignments: any[], hasUser: boolean): any[] {
    const uniqueAssignments = [];
    assignments.forEach(item => {
      if (
        uniqueAssignments.findIndex(element =>
          hasUser ? element.userId === item?.userId : element.id === item?.id
        ) === -1
      ) {
        uniqueAssignments.push(item);
      }
    });

    return uniqueAssignments;
  }

  questionSplitter(indx: number): void {
    let index = this.isRemediate
      ? this.questions[indx].title.indexOf(' ', this.maxCharsInLine - 18)
      : this.questions[indx].name.indexOf(' ', this.maxCharsInLine - 18);
    if (index > 0) {
      if (index > this.maxCharsInLine - 15) {
        index = this.isRemediate
          ? this.questions[indx].title.indexOf(' ', this.maxCharsInLine - 25)
          : this.questions[indx].name.indexOf(' ', this.maxCharsInLine - 25);
      }
      const question = JSON.parse(
        JSON.stringify(this.isRemediate ? this.questions[indx].title : this.questions[indx].name)
      );
      if (this.isRemediate) {
        this.questions[indx].title = this.questions[indx].title.substring(0, index);
      } else {
        this.questions[indx].name = this.questions[indx].name.substring(0, index);
      }
      this.questions[indx].questionExt = question.substring(index);
      this.questions[indx].showMore = true;
      this.questions[indx].showQuestionExt = false;
    } else {
      this.questions[indx].questionExt = '';
      this.questions[indx].showMore = false;
      this.questions[indx].showQuestionExt = false;
    }
  }

  /**
   * Checks if the current user is one of the users assigned to the task.
   * Handles different data structures that might contain userId in different locations.
   *
   * @param usersAssignments - Object containing an array of user assignments
   * @returns boolean - True if current user is assigned to the task, false otherwise
   */
  isCurrentUserTaskOwner(usersAssignments): boolean {
    if (!usersAssignments?.items || !this.currentUser?.id) {
      return false;
    }

    return usersAssignments.items.some(assignment => {
      // Check different possible locations for the user ID
      const assignmentUserId = assignment?.userId || assignment?.user?.id;
      return assignmentUserId === this.currentUser.id;
    });
  }

  buildQuestionsComments(): void {
    // Fetching comments
    this.questions.map(question => {
      const uComments = question?.comments.filter(c => !c?.type || c?.type === 'user');
      const audComments = question?.comments.filter(c => c?.type === 'audit');
      this.userComments[question.id] = [];
      this.auditComments[question.id] = [];
      this.auditComments[question.id] = audComments.map(c => {
        return {
          id: c.id,
          userId: c.userId,
          userName: c.user.items.length ? c.user.items[0].name : c.archivedUser.name,
          date: c.date,
          comment: c.comment,
          type: c.type ? c.type : null,
        };
      });
      this.userComments[question.id] = uComments.map(c => {
        return {
          id: c.id,
          userId: c.userId,
          userName: c.user.items.length ? c.user.items[0].name : c.archivedUser.name,
          date: c.date,
          comment: c.comment,
          type: c.type ? c.type : null,
        };
      });
      return (
        (this.userComments[question.id] = this.userComments[question.id].sort((a, b) => a.date - b.date)),
        (this.auditComments[question.id] = this.auditComments[question.id].sort((a, b) => a.date - b.date))
      );
    });
  }
  getTotalFiles(index: number): number {
    const question = this.questions[index];
    if (!question) {
      return 0;
    }
    let s3Inputs = [];
    s3Inputs = this.tempQuestionsAnswers[index].answers
      .map(ans => ans.file)
      .filter(file => file)
      .flat();

    return s3Inputs.length;
  }

  buildAnswerList(): void {
    this.answers = [];
    this.questions.forEach((question, index) => {
      this.answers[index] = {};
      const isFromTaskOwner = (question?.isAverageSelected && question?.isTaskOwner) || false;

      if (UtilsService.isDefined(question?.selectedUserAssignment)) {
        if (question.answers && question.answers.length > 0) {
          question.answers.forEach(answer => {
            if (
              answer?.user?.id === question?.selectedUserAssignment?.id &&
              isFromTaskOwner === Boolean(answer?.isFromTaskOwner)
            ) {
              this.answers[index] = answer;
            }
          });
        } else if (!!question.managerAnswers && question.managerAnswers.length > 0) {
          question.managerAnswers.forEach(answer => {
            if (answer?.user?.id === question?.selectedUserAssignment?.id) {
              this.answers[index].answer = answer?.answer;
            }
          });
        }
        // sometimes value falls in between in the third party integrations case
        if (this.answers[index]?.answer > 1 && this.answers[index]?.answer < 2.5 && !this.isBnb) {
          this.answers[index].answer = 1;
        }
      } else if (this.userId) {
        if (question.answers && question.answers.length > 0) {
          this.answers[index] = UtilsService.sortByProp(question.answers, 'updatedAt', SortDirectionEnum.DESCENDING)[0];
        } else if (!!question.managerAnswers && question.managerAnswers.length > 0) {
          this.answers[index].answer = question.managerAnswers[0].answer;
        }
        // sometimes value falls in between in the third party integrations case
        if (this.answers && this.answers[index].answer > 1 && this.answers[index].answer < 2.5 && !this.isBnb) {
          this.answers[index].answer = 1;
        }
      } else {
        const allAnswers = question.answers;
        if (allAnswers && allAnswers.length > 0) {
          let averageAnswerValue = allAnswers.reduce((acc, curr) => acc + curr.answer, 0) / allAnswers.length;
          this.answers[index] = UtilsService.sortByProp(allAnswers, 'updatedAt', SortDirectionEnum.DESCENDING)[0];
          // sometimes value falls in between in the third party integrations case
          if (averageAnswerValue > 1 && averageAnswerValue < 2.5) {
            averageAnswerValue = 1;
          }
          this.answers[index].answer = averageAnswerValue;
        }
      }
      this.isPartialSelected[index] =
        this.answers[index]?.answerName?.toLowerCase() === BnbAnswerEnum.PARTIAL.toLowerCase();

      if (this.isPartialSelected[index]) {
        //* populate slider score if partial is selected
        if (this.currentPartialRepresentation[index] === this.PARTIAL_REPRESENTATION_ENUM.PERCENTAGE) {
          this.sliderScore[index] = this.partialPercentageMapping(this.answers[index].answer, false);
        } else {
          this.sliderScore[index] = this.scoreFlipper(this.answers[index].answer, false);
        }
      }
      if (!this.isRemediate) {
        this.isDataFetched = true;
      }

      this.answers[index] = {
        ...this.answers[index],
        frameworkAnswersWithSettings: question.frameworkAnswersWithSettings,
      };
    });
  }

  isDefined(variable: boolean): boolean {
    return UtilsService.isDefined(variable);
  }

  async onSave(): Promise<void> {
    this.saving = true;
    this.showError = false;
    // Answer will only be saved on the save button
    // this.answers.map(answer => {
    //   const res = this.remediatedItemsList.find(obj => obj.answerId === answer.id);
    //   if (res) {
    //     answer.answer = res.sliderScore
    //       ? this.answerEnumToNum(res.answer, answer.frameworkAnswersWithSettings, this.scoreFlipper(res.sliderScore))
    //       : this.answerEnumToNum(res.answer, answer.frameworkAnswersWithSettings, answer.answer);
    //     answer.answerName = res.answer;
    //   }
    // });

    const updatedQuestionsList: Question[] = [];

    if (!this.allQuestionsValid()) {
      this.saving = false;
      return;
    }

    const chunkSize = 10;
    const totalQuestions = this.questions.length;
    // const questionLabel = totalQuestions > 1 ? 'Questions' : 'Question';
    for (let i = 0; i < totalQuestions; i += chunkSize) {
      const chunk = this.questions.slice(i, i + chunkSize);
      const questionPromises = chunk.map(
        (question, chunkIndex) => this.answerQuestion(updatedQuestionsList)(question, i + chunkIndex) // Use global index
      );
      await Promise.all(questionPromises);
      const remediatedQuestions = chunk.filter(question => this.isQuestionRemediated(question));
      updatedQuestionsList.push(...remediatedQuestions);
      // const percentage = Math.ceil((updatedQuestionsList.length / totalQuestions) * 100);
      // this.toastrService.success(`${questionLabel} updated successfully`);
      const isLastChunk = i + chunkSize >= totalQuestions;
      if (!isLastChunk) {
        await new Promise(resolve => setTimeout(resolve, 4000));
      }
    }
    this.artifactsLogsToCreate = [];
    if (updatedQuestionsList && !updatedQuestionsList.length) {
      this.saving = false;
      this.save.emit(updatedQuestionsList);
      return;
    }

    if (!this.isRemediate) {
      this.sunburstService.updateSelected(updatedQuestionsList);
    }

    this.saving = false;
    // if (!this.showError) {
    //   this.toastrService.success('Saved Successfully');
    // }
    this.save.emit(updatedQuestionsList);
  }

  isQuestionRemediated(question: any): boolean {
    return question.isRemediated;
  }

  allQuestionsValid() {
    let commentRequired = false;
    let artifactRequired = false;
    let isAnyUnansweredPartial = false;

    for (const [index, question] of this.questions.entries()) {
      const commentMapper = this.commentAnswerMapper[question.id][this.currentSelectedUserId];

      if (commentMapper && commentMapper?.isCommentRequired) {
        commentRequired = true;
        this.toastrService.error(`Comments are mandatory for question ${index + 1}`);
        break;
      }

      if (commentMapper && commentMapper?.isArtifactRequired) {
        artifactRequired = true;
        this.toastrService.error(`Artifacts are mandatory for question ${index + 1}`);
        break;
      }
      if (
        question.answers.find(
          ans =>
            ans.answerName &&
            ans.answerName.toLowerCase() === AnswerEnum.PARTIAL.toLowerCase() &&
            (ans.answer < 0 || ans.answer === null)
        )
      ) {
        isAnyUnansweredPartial = true;
        this.toastrService.error(`Please choose a partial value for question ${index + 1}`);
        break;
      }
    }

    if (commentRequired || artifactRequired || isAnyUnansweredPartial) {
      return false;
    }

    return true;
  }

  async saveComment(action: string, questionIdx: number, comment: string = null, type: string = null): Promise<void> {
    if (comment?.trim() === '') {
      this.toastrService.error('Please add text in comment');
      return;
    }
    this.isCommentInProgress = true;
    const questionId = this.isRemediate ? this.questions[questionIdx].questionIds[0] : this.questions[questionIdx].id;
    if (action === CommentActionEnum.CREATE && questionId) {
      const date = new Date();
      const commentObj: CreateCommentInput = {
        assessmentId: this.questions[questionIdx].assessmentIds[0],
        questionId,
        userId: this.userId,
        comment,
        date: date.getTime(),
        latestSource: ExportSourceEnum.CYGOV,
        id: uuid(),
        framework: this.questions[questionIdx]?.frameworkName?.toUpperCase(),
        type,
      };
      // saving comments draft
      if (this.commentAnswerMapper[this.questions[questionIdx]?.id]) {
        if (!this.commentAnswerMapper[this.questions[questionIdx]?.id][this.currentSelectedUserId]) {
          this.commentAnswerMapper[this.questions[questionIdx]?.id][this.currentSelectedUserId] = {};
        }
        this.commentAnswerMapper[this.questions[questionIdx]?.id][this.currentSelectedUserId].comments =
          commentObj?.comment;
        this.commentAnswerMapper[this.questions[questionIdx]?.id][this.currentSelectedUserId].commentId =
          commentObj?.id;
      } else {
        this.commentAnswerMapper[this.questions[questionIdx]?.id] = {};
        this.commentAnswerMapper[this.questions[questionIdx]?.id][this.currentSelectedUserId].comments =
          commentObj?.comment;
        this.commentAnswerMapper[this.questions[questionIdx]?.id][this.currentSelectedUserId].commentId =
          commentObj?.id;
      }
      this.draftComment(this.commentAnswerMapper[this.questions[questionIdx]?.id], commentObj);
      const createdComment = await this.questionnaireService.createComment(commentObj);
      if (createdComment.id) {
        this.remediationService.updateTaskCommentState(createdComment);
        const logMessage = getLogMessage(LogsKeyEnum.SAVE_COMMENT, this.currentUser.name);
        const log = await this.entityService.addLog(
          this.questions[questionIdx].assessmentIds[0] + '#' + questionId,
          this.questions[questionIdx].assessmentIds[0],
          `${LogsTypeEnum.QUESTION}#${this.questions[questionIdx]?.frameworkName.toUpperCase()}`,
          logMessage
        );
        if (!this.questions[questionIdx].logs) {
          this.questions[questionIdx].logs = [];
        }
        this.questions[questionIdx].logs.unshift(log);
        this.questions[questionIdx].logsStartIndex = 0;
        this.questions[questionIdx].logsLastIndex = 5;
        this.questions[questionIdx].questionLogs = this.questions[questionIdx]?.logs?.slice(
          this.questions[questionIdx].logsStartIndex,
          this.questions[questionIdx].logsLastIndex
        );
        this.questions[questionIdx].disableUpArrow = this.questions[questionIdx].logsStartIndex <= 0;
        this.questions[questionIdx].disableDownArrow =
          this.questions[questionIdx].logsLastIndex >= this.questions[questionIdx]?.logs?.length;
        this.toastrService.success('Comment added successfully');
      } else {
        this.toastrService.error('Failed Saving Comment');
      }
      this.questionsNewComment[questionId] = '';
      this.questionsAuditComment[questionId] = '';
      this.questions[questionIdx].comments.push(createdComment);
      this.buildQuestionsComments();
    }
    this.isCommentInProgress = false;
    return;
  }
  showMoreLess(qId: any, i: number) {
    if (
      this?.preI !== undefined &&
      this?.prevQid !== undefined &&
      this.userComments[this.prevQid][this.preI]?.show !== undefined &&
      this.userComments[this.prevQid][this.preI].id !== this.userComments[qId][i].id
    ) {
      this.userComments[this.prevQid][this.preI].show = true;
    }
    if (this.userComments[qId][i]?.show !== undefined) {
      {
        this.userComments[qId][i].show = !this.userComments[qId][i].show;
      }
    } else {
      this.userComments[qId][i].show = false;
    }
    this.prevQid = qId;
    this.preI = i;
  }
  async updateComment(commentId, comment, assessmentId, quesiton): Promise<void> {
    if (commentId) {
      const input: UpdateCommentInput = {
        id: commentId,
        latestSource: ExportSourceEnum.CYGOV,
        comment: comment.comment,
        userId: this.userId,
        sType: null,
        assessmentId,
      };
      const commentResult = await this.customApi.UpdateComment(input);
      const logMessage = getLogMessage(LogsKeyEnum.EDIT_COMMENT, this.currentUser.name);
      const log = await this.entityService.addLog(
        quesiton.assessmentIds[0] + '#' + quesiton?.id,
        quesiton.assessmentIds[0],
        `${LogsTypeEnum.QUESTION}#${quesiton?.frameworkName.toUpperCase()}`,
        logMessage
      );
      quesiton?.logs.push(log);
      this.toastrService.success('Comment updated successfully');
      delete commentResult.createdAt;
      delete commentResult.exports;
      delete commentResult.latestSource;
      delete commentResult.updatedAt;
      delete commentResult.user;
      delete commentResult.__typename;
      // update global state of comment which has the same commentId
      const updatedComment = await this.questionnaireService.updateComment(commentResult);
      if (updatedComment.id) {
        this.toastrService.success('Comment updated successfully');
      } else {
        this.toastrService.error('Failed Saving Comment');
      }
    }
  }

  async deleteComment(question, commentId, comment) {
    try {
      if (commentId === '-1') {
        this.toastrService.error('Cannot delete comment');
        return;
      }
      if (commentId) {
        // for infosec we need to update the comment sType to null before deleting it so that updateCommentTrigger behave accurately.
        const sType = this.isBnb && question && question.settings && question.settings.isInfoSec ? 'info_delete' : null;
        const input = {
          id: commentId,
          latestSource: ExportSourceEnum.CYGOV,
          comment: comment.comment,
          sType,
          assessmentId: question.assessmentIds[0],
        };
        if (comment.sType !== null || (this.isBnb && question && question.settings && question.settings.isInfoSec)) {
          await this.customApi.UpdateComment(input);
        }
        const deletedComment = await this.customApi.DeleteComment(
          { id: commentId },
          { assessmentId: { eq: question.assessmentIds[0] } }
        );
        // deleting comment from local state
        this.collectionService.deleteComment(deletedComment);
        // removing comment from this component locally
        const index = question?.comments?.findIndex((c: any) => c.id === commentId);
        if (index > -1) {
          question.comments.splice(index, 1);
        }
        const logMessage = getLogMessage(LogsKeyEnum.DELETE_COMMENT, this.currentUser.name);
        const log = await this.entityService.addLog(
          question?.assessmentIds[0] + '#' + question?.id,
          question.assessmentIds[0],
          `${LogsTypeEnum.QUESTION}#${question?.frameworkName.toUpperCase()}`,
          logMessage
        );
        question?.logs.push(log);
        this.toastrService.success('Comment deleted successfully');
      }
    } catch (e) {
      console.log('Error while deleting comment', e);
    }
  }

  // flips score between slider value and actual score
  scoreFlipper(value, sliderToVal = true): number {
    return UtilsService.partialAnswersMapping(value, sliderToVal);
  }
  getDate(date: number): string {
    return new Date(date).toLocaleDateString('en-GB');
  }

  getCommentDate(date: number): Date {
    const newDate = new Date(date);
    return newDate;
  }

  getUserName(comment: any): string {
    if (comment.user) {
      return comment.user.items && comment.user.items.length ? comment.user.items[0].name : 'None';
    } else if (comment.userName) {
      return comment.userName;
    } else {
      return this.currentUser ? this.currentUser.name : 'None';
    }
  }

  async taskOwnerAnswerQuestion(question, index) {
    const updatedAnswer = await this.questionnaireService.updateTaskOwnerAnswer(
      question,
      this.currentUser?.id,
      this.answers[index],
      question.questionIds[0]
    );
    this.answers[index] = updatedAnswer;

    const status = this.remediationService.getStatus(updatedAnswer.answer);

    const logMessage = getLogMessage(
      status === TaskStatusEnum.REMEDIATED ? LogsKeyEnum.REMEDIATE_TASK_OWNER : LogsKeyEnum.IGNORE_TASK_OWNER,
      this.currentUser.name
    );

    if (this.isRemediate && status === TaskStatusEnum.REMEDIATED) {
      this.entityService.addLog(
        question?.assessmentIds[0] + '#' + question?.questionIds[0],
        question.assessmentIds[0],
        `${LogsTypeEnum.QUESTION}#${question?.frameworkName.toUpperCase()}`,
        logMessage
      );
    }
  }

  answerQuestion =
    (updatedQuestionsList: Question[]) =>
    async (question: any, index): Promise<void> => {
      // Return if not answered
      if (!UtilsService.isDefined(this.answers[index].answer) && !UtilsService.isDefined(this.answers[index].file)) {
        return;
      }
      if (this.answers[index]?.isFromTaskOwner) {
        await this.taskOwnerAnswerQuestion(question, index);
        updatedQuestionsList.push(question);
        return;
      }

      const answerOptionSetting = this.checkOptionIsMandatory(this.answers[index].answer, question);

      // If artifact files not uploaded when mandatory while answering a question YES
      let settingsObject = false;
      for (const prop in question) {
        if (prop === 'settings') {
          settingsObject = true;
          break;
        }
      }

      // Throw error if artifact not uploaded in 1st party & 3rd party vendor compliance framework
      // isFromVendorOrThirdParty gives true if its vendor view or vendor role or third party view
      // if the question is from risk framework and isFromVendorOrThirdParty then its not mandatory to upload artifacts
      if (
        ((settingsObject && question.settings.length && question.settings[0].isArtifactsMandatory) ||
          (this.isFromVendorOrThirdParty && !this.riskFrameworks.includes(question.frameworkName))) &&
        answerOptionSetting?.artifact &&
        !(this.answers[index] && UtilsService.isDefined(this.answers[index].file) && this.answers[index].file.length)
      ) {
        this.toastrService.error('Artifacts are mandatory');
        this.answers[index].answer = this.prevAns ? this.prevAns : this.answers[index].answer;
        this.showError = true;
        return;
      }

      if (
        ((settingsObject && question.settings.length && question.settings[0].isCommentsMandatory) ||
          (this.isFromVendorOrThirdParty && !this.riskFrameworks.includes(question.frameworkName))) &&
        (UtilsService.formatAnswerValue(this.currentSelectedAnswer) === AnswerEnum.NOT_APPLICABLE ||
          UtilsService.formatAnswerValue(this.commentAnswerMapper[question.id]?.[this.currentSelectedUserId]?.ans) ===
            AnswerEnum.NOT_APPLICABLE) &&
        !(UtilsService.isDefined(question?.comments) && question?.comments?.length)
      ) {
        this.toastrService.error('Comments Required');
        this.showError = true;
        return;
      }
      // Initialize answer array if not exists
      if (!question.answers) {
        question.answers = [];
      }

      // Add answer in question answers array
      let userAnswer = this.answers[index];

      // Check if there are pending artifacts (uploaded, linked, or deleted) that need to be saved
      const hasPendingUploadedFiles = this.pendingUploadedFiles.has(index);
      const hasPendingLinkedArtifacts = this.pendingLinkedArtifacts.has(index);
      const hasPendingDeletedFiles =
        this.pendingDeletedFiles.has(index) && (this.pendingDeletedFiles.get(index)?.length ?? 0) > 0;
      const hasPendingArtifacts = hasPendingUploadedFiles || hasPendingLinkedArtifacts || hasPendingDeletedFiles;

      // If answer exists and hasn't changed, but there are pending artifacts, we still need to save
      if (
        userAnswer?.id &&
        !this.cachedAnswers.some(
          oldAns => oldAns?.id === userAnswer?.id && oldAns?.file?.length !== userAnswer?.file?.length
        ) &&
        !hasPendingArtifacts
      ) {
        return;
      }

      // populate actual score if partial is selected
      if (this.isPartialSelected[index]) {
        let partialScore;
        if (this.currentPartialRepresentation[index] === this.PARTIAL_REPRESENTATION_ENUM.PERCENTAGE) {
          partialScore = this.partialPercentageMapping(this.sliderScore[index], true) ?? 5;
        } else {
          // IF scoreFlipper return undefined, it means we click partial but 50% didn't selected. so set 5 value
          partialScore = this.scoreFlipper(this.sliderScore[index]) ? this.scoreFlipper(this.sliderScore[index]) : 5;
        }
        this.answers[index].answer = partialScore;
      }

      // Ensure files are preserved when updating answer
      // Use files from question's answer array as source of truth (contains all uploaded + linked files)
      const currentUserAnswerInQuestion = question.answers?.find(
        ans => ans?.user?.id === this.currentSelectedUserId && !ans?.isFromTaskOwner
      );

      if (currentUserAnswerInQuestion?.file?.length) {
        // Use files from question's answer array as the source of truth
        // This ensures we preserve all files (uploaded + linked artifacts)
        userAnswer.file = [...currentUserAnswerInQuestion.file];
      } else if (userAnswer.file && userAnswer.file.length > 0) {
        // If question's answer doesn't have files but userAnswer does, keep userAnswer files
        // This handles edge cases where files exist in userAnswer but not in question
        userAnswer.file = [...userAnswer.file];
      } else {
        // If no files anywhere, initialize empty array
        userAnswer.file = [];
      }

      // Remove typename for updating s3 files fetched
      if (userAnswer.file) {
        userAnswer.file.forEach(input => delete input.__typename);
      }

      if (
        !this.isRemediate &&
        userAnswer.file?.length &&
        userAnswer?.answer === null &&
        userAnswer?.answerName === null
      ) {
        delete userAnswer.answer;
        delete userAnswer.answerName;
      }

      // Update answer if already answered or add new answer if unanswered
      userAnswer = {
        ...userAnswer,
        comment: `${this.comment}${userAnswer.comment ? userAnswer.comment : ''}\n`,
      };
      question.riskAction = this.comment ? RiskAction.REMEDIATED : null;
      userAnswer.isActionTaken = this.comment ? true : false;
      question.questionId = this.isRemediate
        ? question?.answers.length
          ? question?.questionIds[0]
          : question.id
        : question.id;
      question.score = userAnswer.answer;
      const id = this.isRemediate ? question?.questionIds[0] : question.id;
      const targetId = `${question.assessmentIds[0]}#${id}`;
      const type = `${LogsTypeEnum.QUESTION}#${question.frameworkName.toUpperCase()}`;

      this.currentSelectedUserId = this.isRemediate ? userAnswer?.user?.id : this.currentSelectedUserId;

      if (question.frameworkType) {
        userAnswer.frameworkType = question.frameworkType;
      }

      let answerId = userAnswer.id;
      if (!answerId) {
        const assessmentId = question.assessmentIds[0];
        const questionId = this.isRemediate ? question?.questionIds[0] : question.id;
        answerId = `${this.currentSelectedUserId}#${questionId}#${assessmentId}`;
      }

      if (hasPendingArtifacts && !this.processingPendingArtifacts.has(index)) {
        this.processingPendingArtifacts.add(index);
        try {
          const tempAnswerForArtifacts = {
            id: answerId,
            ...userAnswer,
          } as GetAnswerQuery;

          const pendingUpload = this.pendingUploadedFiles.get(index);
          if (pendingUpload) {
            await this.createArtifactsInRegistry(
              pendingUpload.uploadedFiles,
              tempAnswerForArtifacts,
              pendingUpload.fileArtifactMap,
              index
            );
          }

          const pendingLinked = this.pendingLinkedArtifacts.get(index);
          if (pendingLinked) {
            await this.createLinkedArtifactsInRegistry(
              pendingLinked.artifactIds,
              pendingLinked.artifacts,
              tempAnswerForArtifacts,
              question,
              index
            );
          }
        } catch (error) {
          console.error('Error creating artifacts before answer save:', error);
        } finally {
          this.processingPendingArtifacts.delete(index);
        }
      }

      const savedQuestion = await this.questionnaireService.addAnswerWithAssignments(
        question,
        this.currentSelectedUserId,
        userAnswer,
        this.assignments,
        question.questionId,
        null,
        targetId,
        type,
        this.currentUser.name,
        null,
        null,
        null,
        question?.customScoreArray ?? null
      );

      this.controlDetailsService.setAssignedUsers(question.assignments);
      // remove duplicate assignments from questions object (if any)
      question.assignments = this.getUniqueAssignments(question.assignments, true);
      this.collectionService.addNewAnswerInCache(
        question.questionId,
        savedQuestion.answers.filter(ans => ans?.id),
        true
      );
      this.collectionService.updateAnswerCache(question.questionId, question, false);
      this.collectionService.updateAnswerMap(question, this.currentUser.id, false);

      // Update answer ID in answers array
      const savedAnswer = savedQuestion.answers.find(ans => ans?.user?.id === this.currentSelectedUserId);
      if (savedAnswer?.id) {
        this.answers[index].id = savedAnswer.id;
      }

      if (this.pendingUploadedFiles.has(index)) {
        const pendingUpload = this.pendingUploadedFiles.get(index);
        const uploadedLogMessage = getLogMessage(
          LogsKeyEnum.ARTIFACT_UPLOAD,
          this.currentUser.name,
          null,
          null,
          pendingUpload.uploadedCount
        );

        if (!this.isRemediate) {
          this.artifactsLogsToCreate.push({
            targetId: `${question.assessmentIds[0]}#${question?.id || question?.questionIds?.[0]}`,
            assessmentId: question.assessmentIds[0],
            type: `${LogsTypeEnum.QUESTION}#${question?.frameworkName.toUpperCase()}`,
            message: uploadedLogMessage,
          });
        } else {
          const questionId = question?.questionId || question?.questionIds[0];
          const log = await this.entityService.addLog(
            question.assessmentIds[0] + '#' + questionId,
            question.assessmentIds[0],
            `${LogsTypeEnum.QUESTION}#${question?.frameworkName.toUpperCase()}`,
            uploadedLogMessage
          );
          question?.logs.unshift(log);
        }
        this.pendingUploadedFiles.delete(index);
      }

      if (this.pendingLinkedArtifacts.has(index)) {
        const pendingLinked = this.pendingLinkedArtifacts.get(index);
        if (pendingLinked.artifactIds.length > 0) {
          const linkedLogMessage = getLogMessage(
            LogsKeyEnum.ARTIFACT_UPLOAD,
            this.currentUser.name,
            null,
            null,
            pendingLinked.artifactIds.length
          );

          const linkedQuestionId = question.questionIds?.[0] || question.questionId;
          const linkedTargetId = `${question.assessmentIds[0]}#${linkedQuestionId}`;
          const logType = `${LogsTypeEnum.QUESTION}#${question.frameworkName.toUpperCase()}`;

          if (!this.isRemediate) {
            this.artifactsLogsToCreate.push({
              targetId: linkedTargetId,
              assessmentId: question.assessmentIds[0],
              type: logType,
              message: linkedLogMessage,
            });
          } else {
            await this.entityService.addLog(linkedTargetId, question.assessmentIds[0], logType, linkedLogMessage);
            question?.logs.unshift({
              targetId: linkedTargetId,
              assessmentId: question.assessmentIds[0],
              type: logType,
              message: linkedLogMessage,
            });
          }
        }
        this.pendingLinkedArtifacts.delete(index);
      }

      if (this.pendingDeletedFiles.has(index) && this.pendingDeletedFiles.get(index)?.length > 0) {
        const filesToDelete = this.pendingDeletedFiles.get(index);
        const assessmentId = question.assessmentIds?.[0];
        await this.deleteArtifactsRegistry(filesToDelete, assessmentId);
        this.pendingDeletedFiles.delete(index);
      }

      const logMessage = getLogMessage(LogsKeyEnum.REMEDIATE_TASK, this.currentUser.name);
      const status = this.remediationService.getStatus(question.score);
      //* Artifacts Logs - Create only once when save is clicked for Navigator
      if (!this.isRemediate && this.artifactsLogsToCreate.length) {
        //* find log based on targetId and add the log to question logs
        const foundArtifactLog = this.artifactsLogsToCreate.find(l => l.targetId === targetId);
        if (foundArtifactLog) {
          await this.entityService.addLog(
            foundArtifactLog.targetId,
            foundArtifactLog.assessmentId,
            foundArtifactLog.type,
            foundArtifactLog.message
          );
          question?.logs.unshift(foundArtifactLog);
        }
      }
      if (this.isRemediate && status === TaskStatusEnum.REMEDIATED) {
        this.entityService.addLog(
          question?.assessmentIds[0] + '#' + question?.questionIds[0],
          question.assessmentIds[0],
          `${LogsTypeEnum.QUESTION}#${question?.frameworkName.toUpperCase()}`,
          logMessage
        );
      }
      updatedQuestionsList.push(question);
      this.cdr.detectChanges();
    };

  async onFilePicked(event: any, questionIdx: number): Promise<void> {
    // This method is only called for third-party users
    // First-party users use the modal opened via openQuestionUploadModal()
    let isAnyFileToUpload = false;
    if (event.target.files.length) {
      try {
        // compress file to zip and upload to s3 bucket
        // storing zipfiles multiple instances
        const zipFiles = (
          await Promise.all(
            Array.from(event.target.files).map(async (file: File) => {
              if (file.type === 'application/pdf') {
                if (await this.fileService.scanPdfFile(file)) {
                  this.toastrService.warning('Your File Contain Malicious Content');
                  return null;
                }
              }
              if (FileService.validateFileSize(file)) {
                this.toastrService.warning(file.name + ' Size can not be greater than 30MB');
                return null;
              } else if (!FileService.validateFileType(file, FileTypeEnum.ARTIFACTS)) {
                this.toastrService.warning(file.name + ' File type not supported');
                return null;
              } else {
                isAnyFileToUpload = true;
                const fileInstance = new JSZip().file(file.name, file);
                return {
                  name: file.name,
                  file: (await fileInstance.generateAsync({ type: 'blob' })) as any,
                };
              }
            })
          )
        ).filter(file => UtilsService.isDefined(file));
        if (isAnyFileToUpload) {
          // this.toastrService.info('Uploading...');

          // upload zip files to s3 bucket
          const s3Inputs = zipFiles.map(this.mapS3FileInput);
          if (!UtilsService.isDefined(this.answers[questionIdx].file)) {
            this.answers[questionIdx].file = [];
          }
          this.questions[questionIdx].file = await Promise.all(
            s3Inputs.map(async input => {
              const savedFile = await this.fileService.uploadToS3(input);
              const currentUserAnswerIndex = this.questions[questionIdx]?.answers.findIndex(
                ans => ans?.user?.id === this.currentSelectedUserId
              );

              if (currentUserAnswerIndex > -1) {
                if (!this.questions[questionIdx].answers[currentUserAnswerIndex].file) {
                  this.questions[questionIdx].answers[currentUserAnswerIndex].file = [];
                }

                this.questions[questionIdx].answers[currentUserAnswerIndex].updatedAt = new Date().toISOString();
                this.buildAnswerList();
                this.cachedAnswers = JSON.parse(JSON.stringify(this.answers));

                this.questions[questionIdx].answers[currentUserAnswerIndex].file.push(savedFile);
              } else {
                this.questions[questionIdx].answers.push({
                  answer: null,
                  answerName: null,
                  user: (this.currentUser = await this.userService.getCurrentUser()),
                  file: [savedFile],
                  updatedAt: new Date().toISOString(),
                });
              }
              this.tempQuestionsAnswers = JSON.parse(JSON.stringify(this.questions));
              this.isPartialSelected[questionIdx] =
                this.questions[questionIdx]?.answers[currentUserAnswerIndex]?.answerName?.toLowerCase() ===
                AnswerEnum.PARTIAL.toLowerCase();
              this.buildAnswerList();
            })
          );
          const logMessage = getLogMessage(
            LogsKeyEnum.ARTIFACT_UPLOAD,
            this.currentUser.name,
            null,
            null,
            this.questions[questionIdx].file?.length
          );
          if (!this.isRemediate) {
            //* push the log to array to be created when save is clicked for Navigator
            this.artifactsLogsToCreate.push({
              targetId: `${this.questions[questionIdx].assessmentIds[0]}#${this.questions[questionIdx]?.id}`,
              assessmentId: this.questions[questionIdx].assessmentIds[0],
              type: `${LogsTypeEnum.QUESTION}#${this.questions[questionIdx]?.frameworkName.toUpperCase()}`,
              message: logMessage,
            });
          } else {
            //* Logs for Remediation Modal
            const questionId = this.questions[questionIdx]?.questionId || this.questions[questionIdx]?.questionIds[0];
            const log = await this.entityService.addLog(
              this.questions[questionIdx].assessmentIds[0] + '#' + questionId,
              this.questions[questionIdx].assessmentIds[0],
              `${LogsTypeEnum.QUESTION}#${this.questions[questionIdx]?.frameworkName.toUpperCase()}`,
              logMessage
            );
            this.questions[questionIdx]?.logs.unshift(log);
          }
        }
      } catch (e) {
        this.logger.error('uploadFiles - Error: ', e);
        this.toastrService.error('Failed to upload file');
      }
    }
  }

  async openQuestionUploadModal(questionIdx: number): Promise<void> {
    this.prepareFocusForModalOpen();

    const question = this.questions[questionIdx];
    const allFilesFromAllUsers: any[] = [];
    if (question.answers && question.answers.length > 0) {
      question.answers.forEach(answer => {
        if (answer.file && answer.file.length > 0) {
          allFilesFromAllUsers.push(...answer.file);
        }
      });
    }

    const currentUserAnswer = this.answers[questionIdx] || {
      id: null,
      questionId: question.questionIds?.[0] || question.questionId,
      file: [],
      assessmentId: question.assessmentIds?.[0],
    };

    const answerDetails = {
      ...currentUserAnswer,
      file: allFilesFromAllUsers,
    };

    this.modalReference = this.modalService.open(CollectionQuestionLinkUploadComponent, this.modalOptionsUploadScreen);
    this.modalReference.componentInstance.answerDetails = answerDetails;
    this.modalReference.componentInstance.question = {
      ...question,
      name: (question.title || question.name) + (question.questionExt || ''),
    };
    this.modalReference.componentInstance.frameworkName = question.frameworkName;
    this.modalReference.componentInstance.skipUpload = false;
    this.modalReference.componentInstance.questionNumber = questionIdx + 1;

    // Create pathList if available (similar to collection-question-card)
    const pathList: string[] = [question.frameworkName, question.standards, question.questionNo];

    this.modalReference.componentInstance.pathList = pathList;

    const subEntityId = question?.childIds?.[0] || question?.subEntityId || '';
    this.modalReference.componentInstance.subEntityId = subEntityId;

    this.modalReference.componentInstance.closeModalClicked.subscribe(response => {
      if (response) {
        this.modalReference.close();
      }
    });

    // Handle file save (when files are uploaded)
    this.modalReference.componentInstance.saveFiles.subscribe((response: any) => {
      const files = response?.files || response;
      const uploadedFiles = response?.uploadedFiles || [];
      const uploadedCount = response?.uploadedCount || (Array.isArray(response) ? response.length : 0);

      if (files) {
        // Use only the newly uploaded files passed from the upload component
        // Filter to ensure they have S3 keys (contain '/') to exclude linked artifacts
        const newlyUploadedFiles = uploadedFiles.filter((file: any) => file.key && file.key.includes('/'));

        // Map files using file.key as unique identifier, using existing file.id as childArtifactId
        // Use file.key as the unique identifier since multiple files can have the same name
        const fileArtifactMap = new Map<string, { fileId: string; topLevelArtifactId: string; fileName: string }>();
        for (const file of newlyUploadedFiles) {
          // Use existing file.id from the answer as childArtifactId
          const topLevelArtifactId = file.id;

          // Update file.id in response array
          file.id = uuid();

          // Also update file.id in this.answers[questionIdx].file if the file exists there
          if (this.answers[questionIdx].file) {
            const answerFile = this.answers[questionIdx].file.find(
              f => f.key === file.key || f.id === topLevelArtifactId
            );
            if (answerFile) {
              answerFile.id = file.id;
            }
          }

          // Use file.key as the unique key (S3 path is unique for each file)
          const uniqueKey = file.key || `${file.name}_${Date.now()}_${Math.random()}`;
          fileArtifactMap.set(uniqueKey, { fileId: file.id, topLevelArtifactId, fileName: file.name });
        }

        // Store pending uploaded files - will be processed when save is clicked
        this.pendingUploadedFiles.set(questionIdx, {
          files,
          uploadedFiles: newlyUploadedFiles,
          fileArtifactMap,
          uploadedCount,
        });

        // Update the answer with new files (for UI display only, not saved to DB yet)
        // Use only the current user's existing files + newly uploaded files. Do NOT use response.files,
        // as the modal is initialized with answerDetails which may be another user's answer (e.g. when
        // answers are keyed by "most recent"), so response.files could include another user's artifacts.
        const currentUserAnswerIndex = this.questions[questionIdx]?.answers.findIndex(
          ans => ans?.user?.id === this.currentSelectedUserId
        );

        let existingFilesCurrentUser: any[] = [];
        if (currentUserAnswerIndex > -1 && this.questions[questionIdx].answers[currentUserAnswerIndex].file) {
          existingFilesCurrentUser = [...this.questions[questionIdx].answers[currentUserAnswerIndex].file];
        }

        // Merge: current user's existing files + only the newly uploaded files (never other users' files)
        const mergedFiles = [...existingFilesCurrentUser, ...newlyUploadedFiles];

        // Update files in the answer
        if (!UtilsService.isDefined(this.answers[questionIdx].file)) {
          this.answers[questionIdx].file = [];
        }
        this.answers[questionIdx].file = mergedFiles;

        // Update files in the question's answers array (for UI display)
        if (currentUserAnswerIndex > -1) {
          if (!this.questions[questionIdx].answers[currentUserAnswerIndex].file) {
            this.questions[questionIdx].answers[currentUserAnswerIndex].file = [];
          }
          this.questions[questionIdx].answers[currentUserAnswerIndex].file = mergedFiles;
          this.questions[questionIdx].answers[currentUserAnswerIndex].updatedAt = new Date().toISOString();
        } else {
          this.questions[questionIdx].answers.push({
            answer: null,
            answerName: null,
            user: this.currentUser,
            file: mergedFiles,
            updatedAt: new Date().toISOString(),
          });
        }

        // Update UI
        this.tempQuestionsAnswers = JSON.parse(JSON.stringify(this.questions));
        this.buildAnswerList();
        this.cachedAnswers = JSON.parse(JSON.stringify(this.answers));

        // Show success message
        this.toastrService.success(`${uploadedCount} file(s) added. Click Save to upload.`);
      }
    });

    // Handle linked artifacts
    this.modalReference.componentInstance.artifactsLinked.subscribe(
      (data: { artifactIds: string[]; artifacts: any[] }) => {
        if (data && data.artifactIds && data.artifactIds.length > 0) {
          const { artifactIds, artifacts } = data;

          // Store pending linked artifacts - will be processed when save is clicked
          this.pendingLinkedArtifacts.set(questionIdx, { artifactIds, artifacts });

          // Create file entries for linked artifacts - each artifact gets its own unique ID
          const linkedArtifactFiles = artifacts
            .filter(a => artifactIds.includes(a.id))
            .map(artifact => {
              const fileId = uuid(); // Generate unique ID for each linked artifact
              return {
                id: fileId, // Unique ID for each file entry
                name: artifact.name,
                entityId: this.entityId,
                fileType: FileTypeEnum.ARTIFACTS,
                date: Date.now(),
                contentType: 'application/zip', // Default for artifacts
                key: artifact.id, // Use artifact ID as key for linked artifacts
                userId: this.currentUser.id, // Add userId to identify artifacts by user
              };
            });

          // Update files in the question's answers array first (for UI display)
          const currentUserAnswerIndex = this.questions[questionIdx]?.answers.findIndex(
            ans => ans?.user?.id === this.currentSelectedUserId
          );

          if (currentUserAnswerIndex > -1) {
            if (!this.questions[questionIdx].answers[currentUserAnswerIndex].file) {
              this.questions[questionIdx].answers[currentUserAnswerIndex].file = [];
            }
            // Get existing file identifiers (both id and key) to avoid duplicates
            const existingFileIds = new Set(
              this.questions[questionIdx].answers[currentUserAnswerIndex].file.map((f: any) => f.id)
            );
            // Only include non-null/undefined keys
            const existingFileKeys = new Set(
              this.questions[questionIdx].answers[currentUserAnswerIndex].file.map((f: any) => f.key).filter(key => key)
            );
            // Filter out linked artifacts that are already in the array (check both id and key)
            const newLinkedFiles = linkedArtifactFiles.filter(
              (f: any) => !existingFileIds.has(f.id) && !existingFileKeys.has(f.key)
            );
            // Merge: existing files + new linked artifacts (only if not duplicates)
            this.questions[questionIdx].answers[currentUserAnswerIndex].file = [
              ...this.questions[questionIdx].answers[currentUserAnswerIndex].file,
              ...newLinkedFiles,
            ];
            this.questions[questionIdx].answers[currentUserAnswerIndex].updatedAt = new Date().toISOString();
          } else {
            this.questions[questionIdx].answers.push({
              answer: null,
              answerName: null,
              user: this.currentUser,
              file: linkedArtifactFiles,
              updatedAt: new Date().toISOString(),
            });
          }

          // Update UI
          this.tempQuestionsAnswers = JSON.parse(JSON.stringify(this.questions));
          this.buildAnswerList();
          this.cachedAnswers = JSON.parse(JSON.stringify(this.answers));

          // Show success message
          this.toastrService.success(`${artifactIds.length} artifact(s) linked. Click Save to save.`);
        }
      }
    );
  }

  /**
   * Flattens framework tree and caches questions by questionId
   */
  private async flattenAndCacheFrameworkTree(assessmentId: string, frameworkKey: string): Promise<void> {
    if (this.frameworkTreeCache.has(assessmentId)) {
      return; // Already cached
    }

    try {
      // Get framework tree from S3
      const frameworkTree = await this.frameworkTreeService.getAssessmentTreeFromS3(assessmentId, {
        key: frameworkKey,
      } as any);

      if (!frameworkTree) {
        console.warn(`Framework tree not found for assessmentId: ${assessmentId}, frameworkKey: ${frameworkKey}`);
        return;
      }

      // Flatten tree and cache questions by questionId
      const questionMap = new Map<string, any>();
      const flattenTree = (node: any): void => {
        if (node.questions && Array.isArray(node.questions)) {
          node.questions.forEach((q: any) => {
            if (q.id) {
              questionMap.set(q.id, q);
            }
          });
        }
        if (node.children && Array.isArray(node.children)) {
          node.children.forEach((child: any) => {
            flattenTree(child);
          });
        }
      };

      flattenTree(frameworkTree);
      this.frameworkTreeCache.set(assessmentId, questionMap);
    } catch (error) {
      console.error('Error flattening framework tree:', error);
    }
  }

  /**
   * Gets questionNo from framework tree for a given questionId
   */
  private async getQuestionNoFromTree(
    assessmentId: string,
    frameworkKey: string,
    questionId: string
  ): Promise<string | null> {
    try {
      // Ensure tree is cached
      await this.flattenAndCacheFrameworkTree(assessmentId, frameworkKey);

      const questionMap = this.frameworkTreeCache.get(assessmentId);
      if (questionMap) {
        const questionNode = questionMap.get(questionId);
        if (questionNode && questionNode.order) {
          return (questionNode.order + 1).toString();
        }
      }
    } catch (error) {
      console.error('Error getting questionNo from tree:', error);
    }
    return null;
  }

  /**
   * Fetches subEntityId from entityByAssessmentId query
   * @param assessmentId - The assessment ID to query for
   * @returns The childEntityId (subEntityId) from the entity, or null if not found
   */
  private async getSubEntityIdFromAssessment(assessmentId: string): Promise<string | null> {
    if (!assessmentId) {
      return null;
    }

    try {
      const entityResult = await this.customApi.EntityByAssessmentId(assessmentId, undefined, undefined, 1);
      if (entityResult?.items && entityResult.items.length > 0) {
        const entity = entityResult.items[0];
        return entity?.childEntityId || null;
      }
    } catch (error) {
      console.error('Error fetching subEntityId from entityByAssessmentId:', error);
    }
    return null;
  }

  /**
   * Processes pending artifacts (uploaded files and linked artifacts) after answer is saved
   * This ensures artifacts are uploaded to S3 and registry entries are created when save is clicked
   */
  /**
   * Deletes artifacts from the artifact registry when files are unlinked/deleted
   */
  private async deleteArtifactsRegistry(filesToDelete: any, assessmentId?: string): Promise<void> {
    try {
      const deletePromises = filesToDelete.map(async file => {
        try {
          // Get the artifact registry by questionId with fileId and assessmentId filter
          const filter: ModelArtifactsRegistryFilterInput = {
            fileId: { eq: file.fileId },
            ...(assessmentId && { assessmentId: { eq: assessmentId } }),
          };
          const response = await this.customApi.ArtifactsByQuestionId(file.questionId, undefined, filter, 1000);

          // Get the first matching artifact
          const artifact = response?.items?.[0];

          // Verify it matches answerId
          if (artifact && artifact.answerId === file.answerId) {
            const deleteInput: DeleteArtifactsRegistryInput = {
              id: artifact.id, // Use the ID from the fetched artifact
            };
            await this.customApi.DeleteArtifactsRegistry(deleteInput, {
              entityId: {
                eq: artifact.entityId,
              },
            });
          } else {
            console.warn(
              `Artifact registry for fileId ${file.fileId} does not match answerId or not found, skipping deletion`
            );
          }
        } catch (error) {
          // If artifact doesn't exist or other error, log but don't fail the entire operation
          console.warn(`Failed to delete artifact registry ${file.fileId}:`, error);
        }
      });

      await Promise.all(deletePromises);
    } catch (error) {
      console.error('Error deleting artifacts from registry:', error);
      // Don't throw - allow file deletion to continue even if registry deletion fails
    }
  }

  private async processPendingArtifacts(questionIdx: number, question: any, answerId?: string): Promise<void> {
    // Process pending uploaded files
    const pendingUpload = this.pendingUploadedFiles.get(questionIdx);
    if (pendingUpload) {
      try {
        // Use provided answerId or get from answers array
        const finalAnswerId = answerId || this.answers[questionIdx]?.id;
        if (!finalAnswerId) {
          console.warn('Answer ID not available for pending uploaded files, skipping registry creation');
          this.pendingUploadedFiles.delete(questionIdx);
          return;
        }

        // Create artifacts in registry after answer is saved
        const answerWithId = { ...this.answers[questionIdx], id: finalAnswerId };
        await this.createArtifactsInRegistry(
          pendingUpload.uploadedFiles,
          answerWithId,
          pendingUpload.fileArtifactMap,
          questionIdx
        );

        // Create log entry
        const logMessage = getLogMessage(
          LogsKeyEnum.ARTIFACT_UPLOAD,
          this.currentUser.name,
          null,
          null,
          pendingUpload.uploadedCount
        );

        if (!this.isRemediate) {
          this.artifactsLogsToCreate.push({
            targetId: `${question.assessmentIds[0]}#${question?.id || question?.questionIds?.[0]}`,
            assessmentId: question.assessmentIds[0],
            type: `${LogsTypeEnum.QUESTION}#${question?.frameworkName.toUpperCase()}`,
            message: logMessage,
          });
        } else {
          const questionId = question?.questionId || question?.questionIds[0];
          const log = await this.entityService.addLog(
            question.assessmentIds[0] + '#' + questionId,
            question.assessmentIds[0],
            `${LogsTypeEnum.QUESTION}#${question?.frameworkName.toUpperCase()}`,
            logMessage
          );
          question?.logs.unshift(log);
        }

        // Remove from pending list
        this.pendingUploadedFiles.delete(questionIdx);
      } catch (error) {
        console.error('Error processing pending uploaded files:', error);
        this.toastrService.error('Failed to process uploaded files');
      }
    }

    // Process pending linked artifacts
    const pendingLinked = this.pendingLinkedArtifacts.get(questionIdx);
    if (pendingLinked) {
      try {
        const { artifactIds, artifacts } = pendingLinked;

        // Use provided answerId or get from answers array
        const finalAnswerId = answerId || this.answers[questionIdx]?.id;
        if (!finalAnswerId) {
          console.warn('Answer ID not available for pending linked artifacts, skipping registry creation');
          this.pendingLinkedArtifacts.delete(questionIdx);
          return;
        }

        // Get linked artifact files from answer
        const linkedArtifactFiles = this.answers[questionIdx].file.filter(
          (f: any) => f.key && artifactIds.includes(f.key)
        );

        // Create artifact registry tuples in parallel
        const linkingPromises = artifactIds.map(async artifactId => {
          try {
            if (!artifactId) {
              console.error('Invalid artifactId: artifactId is undefined or null');
              return {
                success: false,
                error: 'Failed to link artifact: Invalid artifact ID',
              };
            }

            const artifact = artifacts.find(a => a.id === artifactId);
            const artifactName = artifact?.name;

            if (!artifact) {
              console.error(`Artifact not found for ID: ${artifactId}`);
              return {
                success: false,
                error: 'Failed to link artifact: Artifact not found',
              };
            }

            const linkedFile = linkedArtifactFiles.find((f: any) => f.key === artifactId);
            if (!linkedFile || !linkedFile.id) {
              console.error(`Could not find file entry for artifact ${artifactId}`);
              return {
                success: false,
                error: `Failed to link artifact: ${artifactName} - file entry not found`,
              };
            }

            const fileId = linkedFile.id;
            const tupleId = uuid();

            const frameworkKey = question.frameworkName || null;
            const assessmentId = question.assessmentIds?.[0];
            const questionId = question.questionIds?.[0] || question.questionId;

            // Fetch subEntityId from entityByAssessmentId query
            const subEntityId =
              (await this.getSubEntityIdFromAssessment(assessmentId)) || question.childIds?.[0] || question.subEntityId;

            // Get questionNo from framework tree
            const questionNo =
              question.questionNo ||
              (assessmentId && frameworkKey && questionId
                ? await this.getQuestionNoFromTree(assessmentId, frameworkKey, questionId)
                : null);

            const createInput: CreateArtifactsRegistryInput = {
              id: tupleId,
              parentID: artifactId,
              entityId: this.entityId,
              subEntityId,
              name: artifactName,
              frameworkName: question.standards || question.frameworkName,
              frameworkKey: UtilsService.extractFrameworkName(frameworkKey),
              assessmentId,
              fileId,
              controlId: question?.controlName,
              controlName: question?.controlLabel,
              questionNo: questionNo ? questionNo.toString() : null,
              questionId,
              linkedBy: this.currentUser.id,
              linkedDate: Math.floor(Date.now() / 1000),
              answerId: finalAnswerId,
              creatorId: artifact.creatorId,
              tags: [],
              categories: [],
              left: question.left,
              right: question.right,
              smartMappingId: question?.smartMappingId,
              status: ArtifactStatus.OPEN,
            };

            if (!createInput.parentID) {
              console.error(`parentID is missing for artifact ${artifactId}`);
              return {
                success: false,
                error: `Failed to link artifact: ${artifactName} - parent ID is missing`,
              };
            }

            const createdTuple = await this.customApi.CreateArtifactsRegistry(createInput);

            return {
              success: true,
              tuple: createdTuple,
            };
          } catch (error) {
            console.error(`Failed to create artifact registry tuple for artifact ${artifactId}:`, error);
            const artifact = artifacts.find(a => a.id === artifactId);
            const artifactName = artifact?.name || 'Unknown';
            return {
              success: false,
              error: `Failed to link artifact: ${artifactName}`,
            };
          }
        });

        const linkingResults = await Promise.all(linkingPromises);

        const createdTuples = linkingResults
          .filter(result => result.success && result.tuple)
          .map(result => result.tuple);

        linkingResults.forEach(result => {
          if (!result.success && result.error) {
            this.toastrService.error(result.error);
          }
        });

        if (createdTuples.length > 0) {
          const logMessage = getLogMessage(
            LogsKeyEnum.ARTIFACT_UPLOAD,
            this.currentUser.name,
            null,
            null,
            createdTuples.length
          );

          const linkedQuestionId = question.questionIds?.[0] || question.questionId;
          const targetId = `${question.assessmentIds[0]}#${linkedQuestionId}`;
          const type = `${LogsTypeEnum.QUESTION}#${question.frameworkName.toUpperCase()}`;

          if (!this.isRemediate) {
            this.artifactsLogsToCreate.push({
              targetId,
              assessmentId: question.assessmentIds[0],
              type,
              message: logMessage,
            });
          } else {
            await this.entityService.addLog(targetId, question.assessmentIds[0], type, logMessage);
            question?.logs.unshift({
              targetId,
              assessmentId: question.assessmentIds[0],
              type,
              message: logMessage,
            });
          }
        }

        // Remove from pending list
        this.pendingLinkedArtifacts.delete(questionIdx);
      } catch (error) {
        console.error('Error processing pending linked artifacts:', error);
        this.toastrService.error('Failed to process linked artifacts');
      }
    }
  }

  /**
   * Creates linked artifacts in the registry before answer save
   */
  private async createLinkedArtifactsInRegistry(
    artifactIds: string[],
    artifacts: any[],
    answer: GetAnswerQuery,
    question: any,
    questionIdx: number
  ): Promise<void> {
    if (!artifactIds || artifactIds.length === 0) {
      return;
    }

    const answerId = answer?.id;
    if (!answerId) {
      console.warn('Answer ID not available, skipping linked artifact registry creation');
      return;
    }

    const linkedArtifactFiles = this.answers[questionIdx].file.filter((f: any) => f.key && artifactIds.includes(f.key));

    const linkingPromises = artifactIds.map(async artifactId => {
      try {
        if (!artifactId) {
          console.error('Invalid artifactId: artifactId is undefined or null');
          this.toastrService.error('Failed to link artifact: Invalid artifact ID');
          return;
        }

        const artifact = artifacts.find(a => a.id === artifactId);
        const artifactName = artifact?.name;

        if (!artifact) {
          console.error(`Artifact not found for ID: ${artifactId}`);
          this.toastrService.error('Failed to link artifact: Artifact not found');
          return;
        }

        const linkedFile = linkedArtifactFiles.find((f: any) => f.key === artifactId);
        if (!linkedFile || !linkedFile.id) {
          console.error(`Could not find file entry for artifact ${artifactId}`);
          this.toastrService.error(`Failed to link artifact: ${artifactName} - file entry not found`);
          return;
        }

        const fileId = linkedFile.id;
        const tupleId = uuid();

        const frameworkKey = question.frameworkName || null;
        const assessmentId = question.assessmentIds?.[0];
        const questionId = question.questionIds?.[0] || question.questionId;

        const subEntityId =
          (await this.getSubEntityIdFromAssessment(assessmentId)) || question.childIds?.[0] || question.subEntityId;

        const questionNo =
          question.questionNo ||
          (assessmentId && frameworkKey && questionId
            ? await this.getQuestionNoFromTree(assessmentId, frameworkKey, questionId)
            : null);

        const createInput: CreateArtifactsRegistryInput = {
          id: tupleId,
          parentID: artifactId,
          entityId: this.entityId,
          subEntityId,
          name: artifactName,
          frameworkName: question.standards || question.frameworkName,
          frameworkKey,
          assessmentId,
          fileId,
          controlId: question?.controlName,
          controlName: question?.controlLabel,
          questionNo: questionNo ? questionNo.toString() : null,
          questionId,
          linkedBy: this.currentUser.id,
          linkedDate: Math.floor(Date.now() / 1000),
          answerId,
          creatorId: artifact.creatorId,
          tags: [],
          categories: [],
          left: question.left,
          right: question.right,
          smartMappingId: question?.smartMappingId,
          status: ArtifactStatus.OPEN,
        };

        await this.customApi.CreateArtifactsRegistry(createInput);
      } catch (error) {
        console.error(`Failed to create artifact registry tuple for artifact ${artifactId}:`, error);
        const artifact = artifacts.find(a => a.id === artifactId);
        const artifactName = artifact?.name;
        this.toastrService.error(`Failed to link artifact: ${artifactName}`);
      }
    });

    await Promise.all(linkingPromises);
  }

  /**
   * Creates artifacts in the registry: first without parent, then with parentId
   * Called before answer is saved to ensure artifacts are created first
   * Uses pre-generated IDs to ensure file.id matches childArtifactId
   */
  private async createArtifactsInRegistry(
    files: any[],
    answer: GetAnswerQuery,
    fileArtifactMap: Map<string, { fileId: string; topLevelArtifactId: string; fileName: string }>,
    questionIdx: number
  ): Promise<void> {
    if (!files || files.length === 0) {
      return;
    }

    const answerId = answer?.id;
    if (!answerId) {
      console.warn('Answer ID not available, skipping artifact registry creation');
      return;
    }

    const question = this.questions[questionIdx];
    const questionId = question?.questionIds?.[0] || question.questionId;
    const frameworkName = question?.standards || question.frameworkName;
    const frameworkKey = question.frameworkName || null;
    const assessmentId = question.assessmentIds?.[0];
    const controlId = question?.controlName;
    const controlName = question?.controlLabel;

    // Fetch subEntityId from entityByAssessmentId query
    const subEntityId =
      (await this.getSubEntityIdFromAssessment(assessmentId)) || question?.childIds?.[0] || question?.subEntityId;

    // Get questionNo from framework tree
    const questionNo =
      question.questionNo ||
      (assessmentId && frameworkKey && questionId
        ? await this.getQuestionNoFromTree(assessmentId, frameworkKey, questionId)
        : null);

    try {
      // Filter only newly uploaded files (those that have been uploaded to S3, not linked artifacts)
      // Uploaded files have S3 path keys (contain '/'), linked artifacts have UUID keys
      const uploadedFiles = files.filter(file => file.key && file.key.includes('/'));

      for (const file of uploadedFiles) {
        // Use file.key as the unique identifier to handle multiple files with same name
        const uniqueKey = file.key || `${file.name}_${Date.now()}_${Math.random()}`;
        const artifactIds = fileArtifactMap.get(uniqueKey);

        if (!artifactIds) {
          console.warn(`No artifact IDs found for file: ${file.name} (key: ${uniqueKey}), skipping`);
          continue;
        }

        const { fileId, topLevelArtifactId, fileName } = artifactIds;

        // Step 1: Create top-level artifact without parentID
        const topLevelCreateInput: CreateArtifactsRegistryInput = {
          id: topLevelArtifactId,
          entityId: this.entityId,
          name: fileName,
          creatorId: this.currentUser.id,
          tags: [],
          categories: [],
        };

        try {
          await this.customApi.CreateArtifactsRegistry(topLevelCreateInput);

          // Step 2: Create subentity tuple - parentID + subEntityId, no questionId
          // This is what the link-upload modal's fetchArtifacts query finds
          if (subEntityId) {
            const subEntityTupleInput: CreateArtifactsRegistryInput = {
              parentID: topLevelArtifactId,
              entityId: this.entityId,
              subEntityId,
              name: fileName,
              creatorId: this.currentUser.id,
              assessmentId,
              tags: [],
              categories: [],
            };
            await this.customApi.CreateArtifactsRegistry(subEntityTupleInput);
          }

          // Step 3: Create artifact with parentID pointing to the top-level artifact
          // Use the same childArtifactId that was set as file.id
          const childCreateInput: CreateArtifactsRegistryInput = {
            id: uuid(), // This matches file.id in the answer
            parentID: topLevelArtifactId, // Set parentID to the top-level artifact
            entityId: this.entityId,
            subEntityId,
            name: fileName,
            frameworkName,
            frameworkKey,
            assessmentId,
            fileId,
            controlId,
            controlName,
            questionNo: questionNo ? questionNo.toString() : null,
            questionId,
            smartMappingId: question?.smartMappingId ? question.smartMappingId : null,
            linkedBy: this.currentUser.id,
            linkedDate: Math.floor(Date.now() / 1000), // Convert milliseconds to seconds for AWSTimestamp
            answerId, // Use the answerId from saved answer
            creatorId: this.currentUser.id,
            tags: [],
            categories: [],
            left: question.left,
            right: question.right,
            status: ArtifactStatus.OPEN,
          };

          await this.customApi.CreateArtifactsRegistry(childCreateInput);
        } catch (error) {
          console.error(`Failed to create artifact registry entries for file ${fileName}:`, error);
          // Continue with other files even if one fails
        }
      }
    } catch (error) {
      console.error('Error creating artifacts in registry:', error);
      // Don't throw - allow upload to complete even if registry creation fails
    }
  }

  mapS3FileInput = (file): S3FileInput => {
    return {
      name: file.name,
      entityId: this.entityId,
      fileType: FileTypeEnum.ARTIFACTS,
      contentType: file.file.type,
      body: file.file,
      date: Date.now(),
    };
  };

  async downloadFile(s3Inputs: S3FileInput[], questionIdx: any): Promise<void> {
    try {
      // Open collection-existing-files modal for 1st party only
      if (!this.isFromVendorOrThirdParty) {
        this.openExistingFilesModal(questionIdx);
        return;
      }

      // Original download logic for vendor/third party
      s3Inputs = this.tempQuestionsAnswers[questionIdx].answers
        .map(ans => ans.file)
        .filter(file => file)
        .flat();
      this.toastrService.info('Preparing file...');
      const blobs = await Promise.all(s3Inputs.map(this.createBlob));
      // Creating one zip to be downloaded
      const zip = new JSZip();
      blobs.forEach(file => {
        zip.file(file.name.concat('.zip'), file.blob);
      });
      const zipFile = await zip.generateAsync({ type: 'blob' });

      saveAs(zipFile, `Artifacts-${this.entityId}.zip`);
    } catch (e) {
      this.logger.error(e);
      this.toastrService.error('Failed downloading file');
    }
  }

  /**
   * Opens the CollectionExistingFilesComponent modal for 1st party users
   */
  openExistingFilesModal(questionIdx: number): void {
    this.prepareFocusForModalOpen();

    const question = this.questions[questionIdx];
    const questionId = question?.questionIds?.[0] || question?.id;

    // Get answers for this question
    let answersToShow: GetAnswerQuery[] = [];
    if (question?.answers && question.answers.length > 0) {
      // For collaborative questions, show all users' artifacts
      if (question.settings?.[0]?.isCollaborative) {
        answersToShow = question.answers;
      } else {
        // For non-collaborative, show current user's answer or all answers
        const currentUserAnswer = question.answers.find(
          ans => ans?.user?.id === this.currentSelectedUserId && !ans?.isFromTaskOwner
        );
        if (currentUserAnswer) {
          answersToShow = [currentUserAnswer];
        } else {
          answersToShow = question.answers;
        }
      }
    }

    // Open the modal
    this.modalReference = this.modalService.open(
      CollectionExistingFilesFirstPartyComponent,
      this.modalOptionsExistingFiles
    );

    // Set up modal inputs
    this.modalReference.componentInstance.question = question;
    this.modalReference.componentInstance.currUserName = this.currentUser?.name || '';
    this.modalReference.componentInstance.assessmentId = question?.assessmentIds?.[0] || '';
    this.modalReference.componentInstance.type = `${LogsTypeEnum.QUESTION}#${question?.frameworkName?.toUpperCase() || ''}`;
    this.modalReference.componentInstance.targetId = `${question?.assessmentIds?.[0] || ''}#${questionId}`;
    this.modalReference.componentInstance.isArtifactsMandatory = question?.settings?.[0]?.isArtifactsMandatory || false;
    this.modalReference.componentInstance.isDisabled = false;
    this.modalReference.componentInstance.questionNo = question?.questionNo || questionId || '';
    this.modalReference.componentInstance.controlId = question?.controlId || question?.controlName || '';
    this.modalReference.componentInstance.controlName = question?.controlLabel || question?.controlName || '';
    this.modalReference.componentInstance.answers = answersToShow;
    // Soft-delete on unlink: registry deletion happens when Save is clicked
    this.modalReference.componentInstance.deferArtifactRegistryDeletion = true;

    // Handle modal close
    this.modalReference.componentInstance.closeModalClicked.subscribe(response => {
      if (response) {
        this.modalReference.close();
      }
    });

    // Handle file deletion updates
    this.modalReference.componentInstance.updateDeletedFiles.subscribe(
      (response: Array<{ fileId: string; questionId: string; answerId: string }>) => {
        if (response && response.length > 0) {
          // Store files to delete from registry (will be deleted on save)
          this.pendingDeletedFiles.set(questionIdx, response);

          // Update local question data after files are deleted
          const deletedFileIds = response.map(f => f.fileId);
          if (question.answers) {
            question.answers.forEach(answer => {
              if (answer.file) {
                answer.file = answer.file.filter(file => !deletedFileIds.includes(file.id));
              }
            });
          }
          // Rebuild answer list to reflect changes
          this.buildAnswerList();
          this.tempQuestionsAnswers = JSON.parse(JSON.stringify(this.questions));
        }
      }
    );
  }

  private prepareFocusForModalOpen(): void {
    if (typeof document === 'undefined') {
      return;
    }

    const activeEl = document.activeElement as HTMLElement | null;
    if (!activeEl) {
      return;
    }

    // NgbModal sets aria-hidden on app root; blur focused trigger first to avoid a11y warning.
    if (typeof activeEl.blur === 'function') {
      activeEl.blur();
    }
  }

  /**
   * Downloads files using artifact registry logic (for 1st party only)
   * Based on CollectionExistingFilesComponent.downloadFile()
   */
  async downloadFileWithArtifactRegistry(s3Inputs: S3FileInput[], questionIdx: any): Promise<void> {
    try {
      const question = this.questions[questionIdx];
      const questionId = question?.questionIds?.[0] || question?.id;

      // Build artifact data cache if not already built for this question
      if (!this.artifactDataCacheByQuestion.has(questionId) && questionId) {
        const assessmentId = question.assessmentIds?.[0];
        await this.buildArtifactDataCache(questionId, assessmentId);
      }

      const artifactDataCache = this.artifactDataCacheByQuestion.get(questionId) || new Map();
      const artifactNameCache = this.artifactNameCacheByQuestion.get(questionId) || new Map();

      s3Inputs = this.tempQuestionsAnswers[questionIdx].answers
        .map(ans => ans.file)
        .filter(file => file)
        .flat();

      if (s3Inputs.length === 0) {
        this.toastrService.info('No files to download');
        return;
      }

      const entityId = s3Inputs[0].entityId || this.entityId;
      const totalFiles = s3Inputs.length;
      const blobs = [];

      this.toastrService.info('Preparing file...');

      for (const file of s3Inputs) {
        // Use artifact data from cache to construct proper download key
        const artifactData = artifactDataCache.get(file.id);
        const downloadParentId = artifactData?.parentID;
        const downloadEntityId = artifactData?.entityId;

        // Construct the download key using fileId (top-level artifact)
        if (downloadParentId && downloadEntityId) {
          file.key = `public/ARTIFACTS_REGISTRY/${downloadEntityId}/${downloadParentId}`;
        }

        // Get artifact name from cache or use file name
        const artifactName = artifactNameCache.get(file.id) || file.name;

        const url = await this.fileService.getPresignedS3DownloadUrl(file?.key);
        const response = await fetch(url);
        const reader = response.body.getReader();
        const chunks = [];

        let completion = false;

        while (!completion) {
          const { done, value } = await reader.read();
          if (done) {
            completion = true;
          } else {
            chunks.push(value);
          }
        }

        const blob = new Blob(chunks);
        // Use the artifact name from registry
        blobs.push({ blob, name: artifactName });
      }

      if (blobs.length === 0) {
        this.toastrService.info('No files to download');
        return;
      }

      const zip = new JSZip();
      if (blobs.length === 1) {
        // Single file: unzip and download with proper name
        const originalFile = await zip.loadAsync(blobs[0].blob);
        const fileName = Object.keys(originalFile.files)[0];
        const downloadFileName = blobs[0].name;
        const fileExtension = fileName.split('.').slice(-1)[0] || downloadFileName.split('.').slice(-1)[0] || 'zip';
        originalFile.files[fileName].async('blob').then(data => {
          if (downloadFileName.includes('.')) {
            saveAs(data, downloadFileName);
          } else {
            saveAs(data, `${downloadFileName}.${fileExtension}`);
          }
        });
        return;
      }

      // Multiple files: unzip each and combine
      const promises = [];
      const fileNames = [];
      blobs.forEach(file => {
        promises.push(this.unZip(file));
      });
      await Promise.all(promises);
      this.unZippedFiles.forEach(item => {
        let name;
        if (!fileNames.includes(item.name)) {
          fileNames.push(item.name);
          name = item.name;
        } else {
          fileNames.push(item.name);
          const counter = fileNames.filter(filename => filename === item.name).length - 1;
          name = counter + '_' + item.name;
        }
        zip.file(name, item.file);
      });
      this.unZippedFiles.length = 0;
      fileNames.length = 0;

      const zipFile = await zip.generateAsync({ type: 'blob' });
      saveAs(zipFile, `Artifacts-${entityId}.zip`);

      // Create log entry
      const logMessage = getLogMessage(LogsKeyEnum.ARTIFACT_DOWNLOAD, this.currentUser?.name, null, null, totalFiles);
      const targetId = `${question.assessmentIds?.[0] || ''}#${questionId}`;
      const type = `${LogsTypeEnum.QUESTION}#${question?.frameworkName?.toUpperCase() || ''}`;
      await this.entityService.addLog(targetId, question.assessmentIds?.[0], type, logMessage);
    } catch (e) {
      this.logger.error(e);
      this.toastrService.error('Failed downloading file');
    }
  }

  /**
   * Builds artifact data cache for download (similar to CollectionExistingFilesComponent.buildExistingFilesData)
   */
  private async buildArtifactDataCache(questionId: string, assessmentId?: string): Promise<void> {
    if (!questionId) {
      return;
    }

    try {
      const artifactNameMap = new Map<string, string>();
      const artifactDataMap = new Map<string, { fileId: string; parentID: string; entityId: string }>();

      const allArtifacts: any[] = [];
      let nextToken: string | null | undefined = null;

      // Fetch all artifacts in batches using ArtifactsByQuestionId query
      do {
        const filter: ModelArtifactsRegistryFilterInput = { assessmentId: { eq: assessmentId } };
        const response = await this.customApi.ArtifactsByQuestionId(
          questionId,
          undefined, // sortDirection
          filter, // filter with assessmentId
          500, // limit
          nextToken || undefined
        );

        if (response?.items) {
          allArtifacts.push(...response.items);
        }

        nextToken = response?.nextToken || null;
      } while (nextToken);

      // Create maps of artifact ID to artifact data (name, fileId, parentID, entityId)
      allArtifacts.forEach(artifact => {
        if (artifact?.id && artifact?.name) {
          artifactNameMap.set(artifact.id, artifact.name);
          const fileId = artifact.fileId || artifact.parentID || artifact.id;
          const artifactData = {
            fileId,
            parentID: artifact.parentID || null,
            entityId: artifact.entityId || null,
          };
          artifactDataMap.set(artifact.id, artifactData);
          if (fileId !== artifact.id) {
            artifactDataMap.set(fileId, artifactData);
          }
        }
        // Also map child artifacts if they exist
        if (artifact?.children?.items) {
          artifact.children.items.forEach(child => {
            if (child?.id && child?.name) {
              artifactNameMap.set(child.id, child.name);
              const childFileId = child.fileId || child.parentID || child.id;
              const childArtifactData = {
                fileId: childFileId,
                parentID: child.parentID || null,
                entityId: child.entityId || artifact.entityId || null,
              };
              artifactDataMap.set(child.id, childArtifactData);
              if (childFileId !== child.id) {
                artifactDataMap.set(childFileId, childArtifactData);
              }
            }
          });
        }
      });

      // Store in component cache per questionId
      this.artifactDataCacheByQuestion.set(questionId, artifactDataMap);
      this.artifactNameCacheByQuestion.set(questionId, artifactNameMap);
    } catch (error) {
      this.logger.debug(`Failed to fetch artifacts by questionId ${questionId}, will use file names:`, error);
    }
  }

  /**
   * Unzips a file blob (helper method for download)
   */
  async unZip(file): Promise<void> {
    const currentZip = new JSZip();
    const originalFile = await currentZip.loadAsync(file.blob);
    const fileName = Object.keys(originalFile.files)[0];
    const data = await originalFile.files[fileName].async('blob');
    this.unZippedFiles.push({ name: file.name, file: data });
  }

  createBlob = async (s3Input: S3FileInput): Promise<{ blob: any; name: string }> => {
    const url = await this.fileService.getPresignedS3DownloadUrl(s3Input?.key);
    const response = await fetch(url);
    const blob = await response.blob();
    return {
      blob,
      name: s3Input.name,
    };
  };

  answerNumToEnum(value: number): AnswerEnum {
    return UtilsService.answerNumToEnum(value);
  }

  // check if the answer is partial
  answerEnumToNum(value: string, frameworkAnswersWithSettings: any, answerValue?: number): number {
    if (this.isBnb) {
      return this.bnbAnswerEnumToNum(value, frameworkAnswersWithSettings);
    }
    if (answerValue > 0 && answerValue < 10) {
      return UtilsService.getScoreOrKey(value, frameworkAnswersWithSettings, answerValue);
    }
    return UtilsService.getScoreOrKey(value, frameworkAnswersWithSettings);
  }

  bnbAnswerEnumToNum(value: string, frameworkAnswersWithSettings): number {
    return UtilsService.getScoreOrKey(value, frameworkAnswersWithSettings);
  }

  checkIfFile(selectedAnswer = 'yes', question = null, questionIndex): boolean {
    const answerOptionSetting = this.checkOptionIsMandatory(selectedAnswer, question);

    if (selectedAnswer?.toLowerCase() === ManagerActionEnum.APPROVE.toLowerCase() || answerOptionSetting?.artifact) {
      if (
        !this.tempQuestionsAnswers[questionIndex]?.answers?.find(qAnswer => {
          return (
            UtilsService.isDefined(qAnswer?.file) &&
            qAnswer?.file?.length > 0 &&
            qAnswer.user.id === this.currentSelectedUserId
          );
        }) &&
        !this.tempQuestionsAnswers[questionIndex]?.managerAnswers?.find(qAnswer => {
          return (
            UtilsService.isDefined(qAnswer?.file) &&
            qAnswer?.file?.length > 0 &&
            qAnswer.user.id === this.currentSelectedUserId
          );
        })
      ) {
        // not removing this code as it might be time saving,
        // if we need to reveert the old functionality regarding mandatory artifacts
        // this.toastrService.info('Please upload artifacts before answering YES', 'Mandatory Artifacts');
        return false;
      }
    }
    return true;
  }

  checkOptionIsMandatory(possibleAnswer: string, question: any) {
    const possibleAnswers = question.possibleAnswers?.map(item => item?.toLowerCase());
    const matchedIndex = possibleAnswers.indexOf(String(possibleAnswer)?.toLowerCase());
    const questionSettings = question.settings[0];
    return {
      artifact:
        !UtilsService.isDefined(questionSettings.suggestedArtifactAnswers) ||
        questionSettings.suggestedArtifactAnswers === 'undefined'
          ? questionSettings.isArtifactsMandatory
          : questionSettings.isArtifactsMandatory &&
            questionSettings.suggestedArtifactAnswers.includes(matchedIndex + 1),
      comment:
        !UtilsService.isDefined(questionSettings.requiredCommentAnswers) ||
        questionSettings.requiredCommentAnswers === 'undefined'
          ? questionSettings.isCommentsMandatory
          : questionSettings.isCommentsMandatory && questionSettings.requiredCommentAnswers.includes(matchedIndex + 1),
    };
  }

  /**
   *
   * @param possibleAnswer (YES,NO,NOT APPLICABLE,PARTIAL)
   * @returns boolean
   */
  mandatoryTextFunction(possibleAnswer: string, question, questionIndex, checkingComment = false): boolean {
    if (question.isAverageSelected) {
      return;
    }

    if (!possibleAnswer) {
      possibleAnswer = this.currentPossibleAnswer;
    }

    let isCommentRequired = false;
    let isArtifactRequired = false;

    const answerOptionSetting = this.checkOptionIsMandatory(possibleAnswer, question);

    if (possibleAnswer === this.commentAnswerMapper[question.id]?.[this.currentSelectedUserId]?.ans) {
      if (UtilsService.formatAnswerValue(possibleAnswer) === this.answerEnum.PARTIAL) {
        this.isPartialSelected[questionIndex] = true;
      } else {
        this.isPartialSelected[questionIndex] = false;
      }
      if (!this.commentAnswerMapper[question.id]?.[this.currentSelectedUserId]?.comments) {
        if (
          UtilsService.formatAnswerValue(possibleAnswer) === this.answerEnum.NOT_APPLICABLE &&
          UtilsService.formatAnswerValue(this.commentAnswerMapper[question.id]?.[this.currentSelectedUserId]?.ans) ===
            this.answerEnum.NOT_APPLICABLE
        ) {
          this.mandatoryText = '(Mandatory comment Please Specify)';
          isCommentRequired = true;

          this.commentAnswerMapper[question.id][this.currentSelectedUserId].isCommentRequired = true;
        }
        if (answerOptionSetting?.comment && question?.settings[0]?.isCommentsMandatory) {
          this.mandatoryText = '(Mandatory comment Please Specify)';
          isCommentRequired = true;
          // eslint-disable-next-line dot-notation
          this.commentAnswerMapper[question.id][this.currentSelectedUserId]['isCommentRequired'] = true;
        }
      }
      const file = this.checkIfFile(possibleAnswer, question, questionIndex);
      if (
        !file &&
        this.commentAnswerMapper[question.id]?.[this.currentSelectedUserId]?.ans === possibleAnswer &&
        question?.settings[0]?.isArtifactsMandatory &&
        answerOptionSetting?.artifact
      ) {
        this.mandatoryText = '(Mandatory artifact Please Specify)';
        isArtifactRequired = true;
        // eslint-disable-next-line dot-notation
        this.commentAnswerMapper[question.id][this.currentSelectedUserId]['isArtifactRequired'] = true;
      }

      if (isArtifactRequired && isCommentRequired) {
        this.mandatoryText = '(Mandatory artifact and comment Please Specify)';
        this.isPartialSelected[questionIndex] = false;

        return true;
      } else if ((isArtifactRequired || isCommentRequired) && !checkingComment) {
        this.isPartialSelected[questionIndex] = false;
        return true;
      } else if (isCommentRequired && checkingComment) {
        this.isPartialSelected[questionIndex] = false;
        return true;
      }

      // eslint-disable-next-line dot-notation
      this.commentAnswerMapper[question.id][this.currentSelectedUserId]['isCommentRequired'] = false;
      // // eslint-disable-next-line dot-notation
      this.commentAnswerMapper[question.id][this.currentSelectedUserId].isArtifactRequired = false;
      this.mandatoryText = '';

      return false;
    }
  }

  /**
   * this function will keep record of comments and answers if user select YES or NOT Applicable
   * @param answer
   * @param questionIndex
   */

  createCache(answer: any, questionIndex): void {
    // this.isCommentsMandatory = this.question?.settings?.isCommentsMandatory;
    // this.myAnswer = selectedAnswer;
    const answerSettings = this.checkOptionIsMandatory(answer, this.questions[questionIndex]);
    this.commentAnswerMapper[this.questions[questionIndex]?.id][this.currentSelectedUserId].ans = answer;
    // this.commentAnswerMapper = this.collectionService.commentAnswerMapper;

    if (answerSettings && (answerSettings.comment || answerSettings.artifact)) {
      // this.commentAnswerMapper[this.questions[questionIndex]?.id] = {};
      this.commentAnswerMapper[this.questions[questionIndex]?.id][this.currentSelectedUserId].ans = answer;
    } else if (UtilsService.formatAnswerValue(answer) === this.answerEnum.NOT_APPLICABLE) {
      if (this.commentAnswerMapper[this.questions[questionIndex]?.id]?.[this.currentSelectedUserId]?.ans) {
        this.commentAnswerMapper[this.questions[questionIndex]?.id][this.currentSelectedUserId].ans = answer;
      } else {
        if (!this.commentAnswerMapper[this.questions[questionIndex]?.id]) {
          this.commentAnswerMapper[this.questions[questionIndex]?.id] = {};
        }
        this.commentAnswerMapper[this.questions[questionIndex]?.id][this.currentSelectedUserId].ans = answer;
      }

      this.collectionService.saveDraft(this.commentAnswerMapper);
    } else {
      if (!this.commentAnswerMapper[this.questions[questionIndex]?.id]) {
        this.commentAnswerMapper[this.questions[questionIndex]?.id] = {};
      }
      // this.commentAnswerMapper[this.questions[questionIndex]?.id][this.currentSelectedUserId].ans = '';
      // this.commentAnswerMapper[this.questions[questionIndex]?.id].isArtifactUploaded = false;
    }
  }

  selectionChanged(sliderScore, answer, questionIdx) {
    if (this.questions[questionIdx]?.settings[0]?.isCollaborative) {
      this.currentSelectedUserId = this.userId;
    }

    const answerKey = Object.keys(this.questions[questionIdx]?.frameworkAnswersWithSettings).find(
      key => this.questions[questionIdx]?.frameworkAnswersWithSettings[key].name.toUpperCase() === answer.toUpperCase()
    );

    const isFromTaskOwner =
      (this.questions[questionIdx]?.isAverageSelected && this.questions[questionIdx]?.isTaskOwner) || false;

    this.currentPossibleAnswer = answer;

    if (!this.commentAnswerMapper[this.questions[questionIdx].id][this.currentSelectedUserId]) {
      this.commentAnswerMapper[this.questions[questionIdx].id][this.currentSelectedUserId] = {};
    }

    const isFileExist = this.questions[questionIdx].answers.find(
      ans => this.currentSelectedUserId === ans?.user?.id && ans?.file?.length
    );

    if (isFileExist) {
      this.commentAnswerMapper[this.questions[questionIdx].id][this.currentSelectedUserId].isArtifactRequired = false;
    }

    if (!isFromTaskOwner) {
      this.createCache(answer, questionIdx);
    }

    this.isPartialSelected[questionIdx] = answer.toLowerCase() === AnswerEnum.PARTIAL.toLowerCase();

    if (this.isPartialSelected[questionIdx] && this.sliderScore[questionIdx] === -1) {
      if (this.currentPartialRepresentation[questionIdx] === this.PARTIAL_REPRESENTATION_ENUM.PERCENTAGE) {
        this.sliderScore[questionIdx] = this.partialPercentageMapping(2.5, false);
      } else {
        this.sliderScore[questionIdx] = UtilsService.partialAnswersMapping(2.5, false);
      }
      sliderScore = this.sliderScore[questionIdx];
    }
    this.prevAns = this.answers[questionIdx].answer;
    // this.answers[questionIdx].answer = this.currentSelectedAnswer = answer;
    const remediatedObjIndex = this.remediatedItemsList.findIndex(obj => {
      return obj.answerId === this.answers[questionIdx].id;
    });

    const index = this.questions[questionIdx].answers?.findIndex(
      ans => ans?.user?.id === this.currentSelectedUserId && Boolean(ans?.isFromTaskOwner) === isFromTaskOwner
    );

    const answerId = isFromTaskOwner
      ? index > -1
        ? this.questions[questionIdx].answers[index]?.id
        : null
      : this.answers[questionIdx]?.id;
    const isCustomScore = this.questions[questionIdx]?.settings[0]?.isCustomScore;
    const customScoreArray = isCustomScore ? this.questions[questionIdx]?.settings[0]?.customScores : null;
    if (index > -1) {
      this.questions[questionIdx].answers[index] = {
        answer: isCustomScore
          ? UtilsService.getScoreOrKeyForCustomScore(answer, customScoreArray)
          : this.answerEnumToNum(
              answerKey,
              this.questions[questionIdx]?.frameworkAnswersWithSettings,
              this.currentPartialRepresentation[questionIdx] === this.PARTIAL_REPRESENTATION_ENUM.PERCENTAGE
                ? this.partialPercentageMapping(sliderScore, true)
                : UtilsService.partialAnswersMapping(sliderScore ? sliderScore : -1)
            ),
        answerName: answer,
        user: this.questions[questionIdx].answers[index].user,
        file: isFileExist?.file ? isFileExist?.file : [],
        updatedAt: new Date().toISOString(),
        isFromTaskOwner,
        date: +new Date(),
      };
    } else {
      this.questions[questionIdx].answers.push({
        answer: isCustomScore
          ? UtilsService.getScoreOrKeyForCustomScore(answer, customScoreArray)
          : this.answerEnumToNum(
              answerKey,
              this.questions[questionIdx]?.frameworkAnswersWithSettings,
              this.currentPartialRepresentation[questionIdx] === this.PARTIAL_REPRESENTATION_ENUM.PERCENTAGE
                ? this.partialPercentageMapping(sliderScore, true)
                : UtilsService.partialAnswersMapping(sliderScore ? sliderScore : -1)
            ),
        answerName: answer,
        user: this.currentUser,
        file: isFileExist?.file ? isFileExist?.file : [],
        answerId,
        updatedAt: new Date().toISOString(),
        isFromTaskOwner,
        date: +new Date(),
      });
    }

    if (remediatedObjIndex === -1) {
      this.remediatedItemsList.push({
        answerId,
        sliderScore,
        answer,
        questionIdx,
      });
    } else {
      this.remediatedItemsList[remediatedObjIndex].sliderScore = sliderScore;
      this.remediatedItemsList[remediatedObjIndex].answer = answer;
    }
    this.buildAnswerList();
  }

  isNotAlreadyAssigned(questionId: string, userId: string) {
    if (this.assignedUsers[questionId]?.length) {
      return this.assignedUsers[questionId]?.findIndex(user => user?.id === userId) === -1;
    } else {
      return true;
    }
  }

  onUsernameClicked(question, index, selectedUserAssignment: GetAssignmentQuery): void {
    this.isUserItSelf = this.currentUser?.id === selectedUserAssignment?.id;

    this.currentSelectedUserId = selectedUserAssignment?.userId
      ? selectedUserAssignment?.userId
      : selectedUserAssignment?.id;

    if (!this.commentAnswerMapper[question.id][this.currentSelectedUserId]) {
      this.commentAnswerMapper[question.id][this.currentSelectedUserId] = {};
    }

    if (this.hasPermission && !question.settings[0].isCollaborative) {
      const answer = question.answers?.find(ans => ans?.user.id === this.currentSelectedUserId && !ans.isFromTaskOwner);
      if (answer && Object.keys(question.frameworkAnswersWithSettings).includes('PARTIAL')) {
        this.isPartialSelected[index] = !(answer?.answer === 1 || answer?.answer === 0 || answer?.answer > 9);
      }
      question.isAverageSelected = false;
      question.selectedUserAssignment = selectedUserAssignment;
    }
    this.buildAnswerList();
  }

  /**
   * Sets the current task owner's answer for a given question.
   *
   * This method checks if the question at the specified index is answered by the task owner.
   * If so, it retrieves the task owner's answer using the `UtilsService.getTaskOwnerAnswer` method
   * and updates the corresponding answer in the `answers` array.
   *
   * @param {number} index - The index of the question in the `questions` array.
   * @returns {boolean} - Returns `true` if the task owner's answer was set, otherwise `false`.
   */
  setCurrentTaskOwnerAnswer(index: number): boolean {
    // *Check if the question is answered from task owner
    this.isPartialSelected[index] = false;
    const taskOwnerAnswer = UtilsService.getTaskOwnerAnswer(this.questions[index].answers);
    if (taskOwnerAnswer) {
      this.answers[index].answer = taskOwnerAnswer.answer;
      this.answers[index].answerName = taskOwnerAnswer.answerName;
      return true;
    }
    return false;
  }

  showAverageAnswer(question, index): void {
    question.isAverageSelected = true;
    //* Set the answer to Task Owner answer if the question is answered from Task Owner
    if (this.setCurrentTaskOwnerAnswer(index)) {
      return;
    }

    // not adding a check that just checks the length of the answers array
    // because when we upload file we create the answers array but the value in the answer remains null
    // so need to check if there exist any valid answer value in array
    const isAnswerAvailable = question?.answers?.some(ans => {
      if (ans.answer || ans.answer === 0) {
        return true;
      }
    });
    if (isAnswerAvailable) {
      const assignmentCount = question.assignments ? question.assignments.length : 0;
      const averageScoreObj = UtilsService.calculateAverageObject(
        { ...question, assignmentCount },
        question.frameworkName
      );
      const averageOfScore = averageScoreObj.answer;
      const averageName = averageScoreObj.answerName;

      this.answers[index].answer = averageOfScore;
      this.answers[index].answerName = averageName;
      this.isPartialSelected[index] = averageName.toLowerCase() === AnswerEnum.PARTIAL.toLowerCase();
      if (this.isPartialSelected[index]) {
        if (this.currentPartialRepresentation[index] === this.PARTIAL_REPRESENTATION_ENUM.PERCENTAGE) {
          this.sliderScore[index] = this.partialPercentageMapping(this.answers[index].answer, false);
        } else {
          this.sliderScore[index] = this.scoreFlipper(this.answers[index].answer, false);
        }
      }
    }
  }

  seeAllActivity(question): void {
    this.selectedQuestion = question;
    this.showActivity = true;
    document.body.style.overflow = 'hidden';
  }

  closeActivities(): void {
    this.showActivity = false;
    this.selectedQuestion = null;
    document.body.style.overflow = 'auto';
  }

  toggleCardOverflow(isHidden: boolean): void {
    const cardEl = document.querySelector('cygov-question-card-ui');

    if (cardEl instanceof HTMLElement) {
      cardEl.style.overflowY = isHidden ? 'hidden' : 'overlay';
    }
  }

  setVersionAnswer(index: number, answer) {
    this.answers[index] = answer;
    this.isPartialSelected[index] =
      this.answers[index] &&
      this.answers[index].answer &&
      this.answers[index].answer >= 2.5 &&
      this.answers[index].answer < 10;
    if (this.isPartialSelected[index]) {
      this.sliderScore[index] = this.scoreFlipper(this.answers[index].answer, false);
    }
  }

  openVersions(question, qIdx: number): void {
    question.showAverageAvatar = !question.showAverageAvatar;
    question.isVersionClicked = !question.isVersionClicked;
    if (question?.questionVersions?.length) {
      if (question.isVersionClicked) {
        question.questionVersions[0].selected = true;
        this.setVersionAnswer(qIdx, question.questionVersions[0]?.data);
      } else {
        for (const ver of question.questionVersions) {
          ver.selected = false;
        }
        if (question.isAverageSelected) {
          this.showAverageAnswer(question, qIdx);
        } else {
          this.buildAnswerList();
        }
      }
    }
  }

  selectVersion(question, qIdx: number, version): void {
    for (const ver of question.questionVersions) {
      if (ver.date === version.date) {
        ver.selected = true;
      } else if (ver.selected) {
        ver.selected = false;
      }
    }
    this.setVersionAnswer(qIdx, version.data);
  }

  /**
   * @param element is type HTMLElement on which the Scroll is added
   * @param moveDirection is type of ArrowEnum either 'up' or 'down' string
   */
  moveScrollLog(question, moveDirection: string): void {
    const scrollAmount = 5;
    const currentDisplayCount = question.logsLastIndex - question.logsStartIndex;
    const totalLogs = question.logs?.length || 0;

    if (moveDirection.toLowerCase() === ArrowsEnum.UP.toLowerCase() && !question.disableUpArrow) {
      const defaultDisplayCount = 5;
      question.logsStartIndex = Math.max(0, question.logsStartIndex - scrollAmount);
      const maxLastIndex = Math.min(totalLogs, question.logsStartIndex + defaultDisplayCount);
      question.logsLastIndex = maxLastIndex;
    } else if (moveDirection.toLowerCase() === ArrowsEnum.DOWN.toLowerCase() && !question.disableDownArrow) {
      const newStartIndex = question.logsStartIndex + scrollAmount;
      const remainingLogsAfterScroll = totalLogs - newStartIndex;

      if (remainingLogsAfterScroll > 0 && remainingLogsAfterScroll < currentDisplayCount) {
        question.logsStartIndex = totalLogs - remainingLogsAfterScroll;
        question.logsLastIndex = totalLogs;
      } else if (remainingLogsAfterScroll <= 0) {
        const remainingFromCurrent = totalLogs - question.logsStartIndex;
        if (remainingFromCurrent > 0 && remainingFromCurrent < currentDisplayCount) {
          question.logsLastIndex = totalLogs;
        }
      } else {
        const maxStartIndex = totalLogs - currentDisplayCount;
        question.logsStartIndex = Math.min(maxStartIndex, newStartIndex);
        question.logsLastIndex = question.logsStartIndex + currentDisplayCount;
      }
    }

    if (question.questionLogs) {
      question.questionLogs = question?.logs?.slice(question.logsStartIndex, question.logsLastIndex);
      question.disableUpArrow = question.logsStartIndex <= 0;
      question.disableDownArrow = question.logsLastIndex >= totalLogs;
    }
  }

  editComments(question, isOpen) {
    question.isEditComments = !question.isEditComments;
    question.showFullComment = false;
    question.isCommentDeleted = false;
    if (!isOpen) {
      this.buildQuestionsComments();
      question.commentsToUpdate = [];
      question.commentsToDelete = [];
    }
  }

  saveResult(question) {
    question.commentsToUpdate.map(async comment => {
      await this.updateComment(comment.id, comment, question.assessmentId, question);
      this.userComments[question.id].forEach(cmnt => {
        if (cmnt.id === comment.id) {
          cmnt.comment = comment.comment;
        }
      });
    });

    question.commentsToDelete.map(async comment => {
      await this.deleteComment(question, comment.id, comment);
    });
    question.isEditComments = false;
    question.commentsToUpdate = [];
    question.commentsToDelete = [];
  }

  showMore(question, comment) {
    question.showFullComment = true;
    question.currentComment = comment;
  }

  showLess(question) {
    question.showFullComment = false;
  }

  addCommentIds(question, commentId, event?) {
    if (commentId !== -1) {
      question.commentsToUpdate.push({ id: commentId, comment: event.target.value });
    }
  }

  deleteComments(question, index: number) {
    question.isCommentDeleted = true;
    const comment: any = this.userComments[question.id][index];
    this.userComments[question.id].splice(index, 1);
    question.commentsToDelete.push(comment);
  }

  // Checks for either the comment input is focused or not
  focusing(isFocused, event) {
    if (isFocused) {
      event.target.classList.add('input-focused');
    } else {
      event.target.classList.remove('input-focused');
    }
  }

  toggle(questionId): void {
    const totalQuestions = this.questions.length;
    this.collapsedQuestion = Array.from(Array<boolean>(totalQuestions).fill(false));
    this.collapsedQuestion[questionId] = !this.collapsedQuestion[questionId];
  }

  toggleCollapse(questionIdx) {
    this.collapsedQuestion[questionIdx] = !this.collapsedQuestion[questionIdx];
  }

  sortCommentsAscending(): void {
    this.questions.forEach(task => {
      task.comments.sort((a: GetCommentQuery, b: GetCommentQuery) => a.date - b.date);
    });
  }

  ifHigherRoles() {
    const role = this.userService.getCurrentRole().name.toUpperCase();
    return (
      role === RoleEnum.ADMIN ||
      role === RoleEnum.LEADER ||
      role === RoleEnum.MSSP ||
      role === AppLevelRoleEnum.ENTITY_LEADER.toUpperCase()
    );
  }

  getFrameworkName(val: string): string {
    const isFrameworkKey = this.domainFrameworkService.isFrameworkKey(val);
    return isFrameworkKey ? this.domainFrameworkService.getFrameworkName(val) : val;
  }

  isDisabledAnswer(answerIndex: number, question: any): boolean {
    let isDisabled = false;
    const realIndex = answerIndex + 1; // Because answerIndex is 0-based and disabledAnswers is 1-based
    const disableAnswers = question.settings[0]?.disableAnswers;
    if (disableAnswers) {
      let disableAnswersArray: number[];
      if (typeof disableAnswers === 'string') {
        disableAnswersArray = disableAnswers.split(',').map(value => Number(value.trim()));
      } else if (Array.isArray(disableAnswers)) {
        disableAnswersArray = disableAnswers.map(value => Number(value));
      } else if (typeof disableAnswers === 'number') {
        disableAnswersArray = [disableAnswers];
      } else {
        disableAnswersArray = [];
      }
      isDisabled = disableAnswersArray.includes(realIndex);
    }
    return isDisabled;
  }

  getAnswerToolTip(possibleAnswer: string, question: any): string {
    let toolTip = '';
    switch (true) {
      case possibleAnswer === 'In Place with Customized Approach' && question.customizedApproachToolTip:
        toolTip = question.customizedApproachToolTip;
        break;
      case possibleAnswer === 'No' && !!question.settings[0].noToolTip:
        toolTip = question.settings[0].noToolTip;
        break;
      case possibleAnswer === 'Partly' && !!question.settings[0].partlyToolTip:
        toolTip = question.settings[0].partlyToolTip;
        break;
      case possibleAnswer === 'Mostly' && !!question.settings[0].mostlyToolTip:
        toolTip = question.settings[0].mostlyToolTip;
        break;
      case possibleAnswer === 'Fully' && !!question.settings[0].fullyToolTip:
        toolTip = question.settings[0].fullyToolTip;
        break;
      case possibleAnswer === 'Advanced' && !!question.settings[0].advancedToolTip:
        toolTip = question.settings[0].advancedToolTip;
        break;
      default:
        break;
    }
    return toolTip;
  }

  ngOnDestroy(): void {
    this.subscription.forEach(listener => listener.unsubscribe());
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  lastAnswer(question, assignment, index) {
    if (question.isVersionClicked) {
      const ans = this.answers[index];
      return question?.settings[0]?.isCollaborative && ans.user.id === assignment.user.id;
    } else {
      const lastAnswer = UtilsService.sortByProp(question.answers, 'updatedAt', SortDirectionEnum.DESCENDING)[0] as any;
      return question?.settings[0]?.isCollaborative && lastAnswer?.user?.id === assignment?.user?.id;
    }
  }

  draftComment(commentAnswerMapper, commentObj) {
    if (
      !commentAnswerMapper[this.currentSelectedUserId] ||
      !Object.keys(commentAnswerMapper[this.currentSelectedUserId])?.length
    ) {
      commentAnswerMapper[this.currentSelectedUserId] = {};
    }
    commentAnswerMapper[this.currentSelectedUserId].comments = commentObj?.comment;
    commentAnswerMapper[this.currentSelectedUserId].commentId = commentObj?.id;
  }

  isOptionChecked(questionIdx, answer, question): boolean {
    if (this.answers[questionIdx].answer === null) {
      return false;
    }
    let res;
    if (this.questions[questionIdx].isCustomScore) {
      const customScoreArray = this.questions[questionIdx].customScoreArray;
      res =
        this.answers[questionIdx].answer >= 0 &&
        this.answers[questionIdx].answer === UtilsService.getScoreOrKeyForCustomScore(answer, customScoreArray);
    } else {
      if (answer.toLowerCase() === AnswerEnum.PARTIAL.toLowerCase()) {
        const partialValues = [2.5, 5, 7.5, 9];
        const isPartialScore = partialValues.includes(this.answers[questionIdx].answer);
        const isPartialAnswer =
          this.answers[questionIdx].answerName?.toLowerCase() === AnswerEnum.PARTIAL.toLowerCase();
        if (isPartialScore || isPartialAnswer) {
          return true;
        }
      }

      // Handle NOT_APPLICABLE variants
      if (UtilsService.isNotApplicableAnswer(answer)) {
        res =
          this.answers[questionIdx].answer >= 0 &&
          UtilsService.isNotApplicableAnswer(this.answers[questionIdx]?.answerName);
      } else {
        res =
          this.answers[questionIdx].answer >= 0 &&
          this.answers[questionIdx]?.answerName.toLowerCase() === answer.toLowerCase() &&
          this.answers[questionIdx].answer ===
            this.answerEnumToNum(answer, question.frameworkAnswersWithSettings, this.answers[questionIdx]?.answer);
      }
    }

    return res;
  }

  showUploadFileIcon(question): boolean {
    if (question.isAverageSelected) {
      return true;
    } else if (question?.settings[0].isCollaborative) {
      return false;
    } else if (!this.isUserItSelf) {
      return true;
    } else {
      return false;
    }
  }

  //* Maps the partial percentage value based on the slider direction.
  private partialPercentageMapping(value: number, sliderToVal: boolean): number {
    return UtilsService.partialPercentageMapping(value, sliderToVal);
  }
}
